import {
  toTitleCase,
  type KpisDto,
  type BrandPriceStats,
  type PriceAdjustmentProductItem,
  type PriceRoundingStrategy,
  type PriceAdjustmentStatus,
} from '@mapara/core';

export type ScreenGroup = 'Pilotage' | 'GTIN' | 'Catalogue' | 'Grossistes B2B' | 'Sources & diffusion' | 'Gestion Logistique' | 'Accounting';

export interface Screen {
  readonly index: string;
  readonly title: string;
  readonly href: string;
  readonly phase: string;
  readonly group: ScreenGroup;
  readonly implemented?: true;
}

export const SCREENS = [
  {
    index: 'S01',
    title: 'Tableau de bord',
    href: '/',
    phase: 'P0',
    group: 'Pilotage',
    implemented: true,
  },
  {
    index: 'S02',
    title: 'GTIN Workbench',
    href: '/workbench',
    phase: 'P2 (live)',
    group: 'GTIN',
    implemented: true,
  },
  {
    index: 'S03',
    title: 'Conflits',
    href: '/conflicts',
    phase: 'P2 (live)',
    group: 'GTIN',
    implemented: true,
  },
  {
    index: 'S07',
    title: 'QualitÃ© du matching',
    href: '/matching-quality',
    phase: 'P2 (live)',
    group: 'GTIN',
    implemented: true,
  },
  {
    index: 'S23',
    title: 'Final EAN Match',
    href: '/final-ean-match',
    phase: 'Live',
    group: 'GTIN',
    implemented: true,
  },
  {
    index: 'S19',
    title: 'Rapprochement Prix & TVA',
    href: '/gtin-pricing-vat',
    phase: 'Live',
    group: 'Grossistes B2B',
    implemented: true,
  },
  {
    index: 'S04',
    title: 'Produits',
    href: '/products',
    phase: 'P1',
    group: 'Catalogue',
    implemented: true,
  },
  {
    index: 'S06',
    title: 'Fichiers fournisseurs',
    href: '/supplier-files',
    phase: 'P1',
    group: 'Catalogue',
    implemented: true,
  },
  { index: 'S08', title: 'Prix & TVA (Arbitrage)', href: '/pricing-vat', phase: 'P4', group: 'Catalogue', implemented: true },
  {
    index: 'S20',
    title: 'NouveautÃ©s Grossistes B2B',
    href: '/b2b-new-products',
    phase: 'Live',
    group: 'Grossistes B2B',
    implemented: true,
  },
  {
    index: 'S15',
    title: 'Stats Ventes',
    href: '/sales-stats',
    phase: 'Live',
    group: 'Grossistes B2B',
    implemented: true,
  },
  {
    index: 'S24',
    title: 'Comparatif GTIN Site ⇄ App',
    href: '/gtin-compare',
    phase: 'Live',
    group: 'GTIN',
    implemented: true,
  },
  {
    index: 'S09',
    title: 'Export Sage',
    href: '/sage-export',
    phase: 'P1 (quick win)',
    group: 'Sources & diffusion',
    implemented: true,
  },
  {
    index: 'S10',
    title: 'Sync WooCommerce',
    href: '/woo-sync',
    phase: 'P3',
    group: 'Sources & diffusion',
    implemented: true,
  },
  { index: 'S05', title: 'Sources', href: '/sources', phase: 'P5', group: 'Sources & diffusion' },
  {
    index: 'S21',
    title: 'Enrichissement Produits',
    href: '/enrichment',
    phase: 'P6 (live)',
    group: 'Catalogue',
    implemented: true,
  },
  {
    index: 'S33',
    title: 'Image Studio',
    href: '/image-studio',
    phase: 'Live',
    group: 'Catalogue',
    implemented: true,
  },
  {
    index: 'S29',
    title: 'Produits masqués',
    href: '/hidden-products',
    phase: 'Live',
    group: 'Catalogue',
    implemented: true,
  },
  {
    index: 'S30',
    title: 'Inventaire rapide',
    href: '/inventory',
    phase: 'Live',
    group: 'Catalogue',
    implemented: true,
  },
  {
    index: 'S31',
    title: 'Ruptures & disponibilité',
    href: '/out-of-stock',
    phase: 'Live',
    group: 'Catalogue',
    implemented: true,
  },
  {
    index: 'S22',
    title: 'Nouveautés Marché & Découverte Produits',
    href: '/crawled-new-products',
    phase: 'P6 (live)',
    group: 'Catalogue',
    implemented: true,
  },
  {
    index: 'S13',
    title: "Vue d'ensemble",
    href: '/shipping',
    phase: 'Live',
    group: 'Gestion Logistique',
    implemented: true,
  },
  {
    index: 'S14',
    title: 'CA Livraison',
    href: '/shipping/ca',
    phase: 'Live',
    group: 'Gestion Logistique',
    implemented: true,
  },
  {
    index: 'S16',
    title: 'Réconciliation Colis',
    href: '/shipping/reconciliation',
    phase: 'Live',
    group: 'Gestion Logistique',
    implemented: true,
  },
  {
    index: 'S35',
    title: 'Shop Manager (Préparation)',
    href: '/shop-manager',
    phase: 'Live',
    group: 'Gestion Logistique',
    implemented: true,
  },
  {
    index: 'S36',
    title: 'Paiements & Rapprochement',
    href: '/shipping/payments',
    phase: 'Live',
    group: 'Gestion Logistique',
    implemented: true,
  },
  {
    index: 'S37',
    title: 'Retours & Délais (+3j)',
    href: '/shipping/retours',
    phase: 'Live',
    group: 'Gestion Logistique',
    implemented: true,
  },
  {
    index: 'S38',
    title: 'Échanges Client (État 3)',
    href: '/shipping/echanges',
    phase: 'Live',
    group: 'Gestion Logistique',
    implemented: true,
  },
  {
    index: 'S39',
    title: 'Enquête Annulations (État 6)',
    href: '/shipping/annulations',
    phase: 'Live',
    group: 'Gestion Logistique',
    implemented: true,
  },
  {
    index: 'S40',
    title: 'Analytique & Perf.',
    href: '/shipping/analytics',
    phase: 'Live',
    group: 'Gestion Logistique',
    implemented: true,
  },
  {
    index: 'S41',
    title: 'Tournées Livreurs',
    href: '/shipping/runsheets',
    phase: 'Live',
    group: 'Gestion Logistique',
    implemented: true,
  },
  {
    index: 'S42',
    title: 'Configuration Logistique',
    href: '/shipping/config',
    phase: 'Live',
    group: 'Gestion Logistique',
    implemented: true,
  },
  {
    index: 'S43',
    title: 'Suivi Client (Public)',
    href: '/suivi',
    phase: 'Live',
    group: 'Gestion Logistique',
    implemented: true,
  },
  { index: 'S11', title: 'Audit', href: '/audit', phase: 'P2', group: 'Pilotage', implemented: true },
  { index: 'S12', title: 'Réglages', href: '/settings', phase: 'P1', group: 'Pilotage', implemented: true },
  {
    index: 'S46',
    title: 'Emails Transactionnels & Notifications',
    href: '/settings/email',
    phase: 'Live',
    group: 'Pilotage',
    implemented: true,
  },
  {
    index: 'S25',
    title: 'Delivred by YM',
    href: '/accounting/delivered-by-ym',
    phase: 'Live',
    group: 'Accounting',
    implemented: true,
  },
  {
    index: 'S26',
    title: 'CA Carrier',
    href: '/accounting/carrier-ca',
    phase: 'Live',
    group: 'Accounting',
    implemented: true,
  },
  {
    index: 'S27',
    title: 'Prix Concurrents',
    href: '/prices/competitors',
    phase: 'Live',
    group: 'Catalogue',
    implemented: true,
  },
  {
    index: 'S28',
    title: 'Ajustement Prix',
    href: '/price-adjustment',
    phase: 'Live',
    group: 'Catalogue',
    implemented: true,
  },
  {
    index: 'S32',
    title: 'Contrôle des Marges',
    href: '/catalogue/marge-control',
    phase: 'Live',
    group: 'Catalogue',
    implemented: true,
  },
  {
    index: 'S34',
    title: 'Audit & Optimisation SEO',
    href: '/catalogue/seo',
    phase: 'Live',
    group: 'Catalogue',
    implemented: true,
  },
  {
    index: 'S44',
    title: 'Veille Prix Marché',
    href: '/catalogue/market-price-changes',
    phase: 'Live',
    group: 'Catalogue',
    implemented: true,
  },
  {
    index: 'S45',
    title: 'Conformité Meta (Facebook Ads)',
    href: '/catalogue/meta-commerce',
    phase: 'Live',
    group: 'Catalogue',
    implemented: true,
  },
] as const satisfies readonly Screen[];

export const SCREEN_GROUPS: readonly ScreenGroup[] = [
  'Pilotage',
  'GTIN',
  'Catalogue',
  'Grossistes B2B',
  'Sources & diffusion',
  'Gestion Logistique',
  'Accounting',
];

/** True when the screen is a roadmap placeholder rather than a working view. */
export function isPlanned(screen: Screen): boolean {
  return screen.implemented !== true;
}

export function screenFor(pathname: string): Screen | undefined {
  if (pathname.startsWith('/catalogue/market-price-changes') || pathname === '/market-price-changes') {
    return SCREENS.find((s) => s.href === '/catalogue/market-price-changes');
  }
  if (pathname === '/accounting/carrier-ca') return SCREENS.find((s) => s.href === '/accounting/carrier-ca');
  if (pathname.startsWith('/accounting')) return SCREENS.find((s) => s.href === '/accounting/delivered-by-ym');
  if (pathname.startsWith('/settings')) return SCREENS.find((s) => s.href === '/settings');
  if (pathname.startsWith('/gtin-pricing-vat')) return SCREENS.find((s) => s.href === '/gtin-pricing-vat');
  if (pathname.startsWith('/b2b-new-products')) return SCREENS.find((s) => s.href === '/b2b-new-products');
  if (pathname.startsWith('/image-studio')) return SCREENS.find((s) => s.href === '/image-studio');
  if (pathname.startsWith('/enrichment')) return SCREENS.find((s) => s.href === '/enrichment');
  if (pathname.startsWith('/shop-manager')) return SCREENS.find((s) => s.href === '/shop-manager');
  if (pathname.startsWith('/shipping/runsheets')) return SCREENS.find((s) => s.href === '/shipping/runsheets');
  if (pathname.startsWith('/shipping/ca') || pathname.startsWith('/shipping/payment-slips') || pathname.startsWith('/shipping/bordereaux')) return SCREENS.find((s) => s.href === '/shipping/ca');
  if (pathname.startsWith('/shipping/reconciliation')) return SCREENS.find((s) => s.href === '/shipping/reconciliation');
  if (pathname.startsWith('/shipping/payments')) return SCREENS.find((s) => s.href === '/shipping/payments');
  if (pathname.startsWith('/shipping/retours') || pathname.startsWith('/shipping/returns-scan')) {
    return SCREENS.find((s) => s.href === '/shipping/retours');
  }
  if (pathname.startsWith('/shipping/echanges')) return SCREENS.find((s) => s.href === '/shipping/echanges');
  if (pathname.startsWith('/shipping/annulations')) return SCREENS.find((s) => s.href === '/shipping/annulations');
  if (pathname.startsWith('/shipping/analytics')) return SCREENS.find((s) => s.href === '/shipping/analytics');
  if (pathname.startsWith('/shipping/config')) return SCREENS.find((s) => s.href === '/shipping/config');
  if (pathname.startsWith('/suivi') || pathname.startsWith('/tracking')) return SCREENS.find((s) => s.href === '/suivi');
  return SCREENS.find((screen) => screen.href === pathname);
}

export async function fetchJson<T>(path: string, init?: RequestInit): Promise<T> {
  const hasBody = init?.body !== undefined && init.body !== null;
  const isFormData = typeof FormData !== 'undefined' && init?.body instanceof FormData;
  const headers = new Headers(init?.headers);
  if (!headers.has('accept')) {
    headers.set('accept', 'application/json');
  }
  if (hasBody && !isFormData && !headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }
  const response = await fetch(path, {
    credentials: 'include',
    ...init,
    headers,
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as Record<string, unknown>;
    const err = new Error(
      [body.error, body.detail].filter(Boolean).join(' â€” ') || `HTTP ${response.status}`,
    ) as Error & Record<string, unknown>;
    Object.assign(err, body);
    throw err;
  }
  return (await response.json()) as T;
}

export interface LoginResult {
  readonly email: string;
  readonly role: string;
  /** carrier portal scope (e.g. Jetpack): non-null = read-only carrier login */
  readonly carrierScope: string | null;
  /** brand distributor portal scope (e.g. ISDIN, ACM, DERMACEUTIC): non-null = read-only brand distributor login */
  readonly brandScope: string | null;
}

export function login(email: string, password: string): Promise<LoginResult> {
  return fetchJson('/api/auth/login', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
}

export function logout(): Promise<{ ok: boolean }> {
  return fetchJson('/api/auth/logout', { method: 'POST' });
}

export function me(): Promise<LoginResult> {
  return fetchJson('/api/auth/me');
}

/** PIN login (shop-floor terminals): email + 4-8 digit PIN. */
export function loginPin(email: string, pin: string): Promise<LoginResult> {
  return fetchJson('/api/auth/login-pin', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ email, pin }),
  });
}

export function fetchKpis(): Promise<KpisDto> {
  return fetchJson('/api/v1/kpis');
}

export interface ProductRow {
  readonly id: number;
  readonly sku: string | null;
  readonly name: string;
  readonly brand: string | null;
  readonly wcType: string;
  readonly isPublished: boolean;
  readonly isVisible: boolean;
  readonly isBundle: boolean;
  readonly isVariation: boolean;
  readonly wooVirtual: boolean | null;
  readonly wooDownloadable: boolean | null;
  readonly barcodeRaw: string | null;
  readonly eanRaw: string | null;
  readonly regularPriceTtc: string | number | null;
  readonly salePriceTtc: string | number | null;
  readonly vatPercent: number | null;
  readonly vatSourceLabel: string | null;
  readonly purchasePriceHt: number | null;
  readonly status?: string;
  readonly inStock?: boolean | null;
  readonly stockQty: number | null;
}

export interface ProductPage {
  readonly total: number;
  readonly page: number;
  readonly pageSize: number;
  readonly items: readonly ProductRow[];
}

export function fetchProducts(
  page: number,
  q: string,
  site?: string,
  flags?: readonly string[],
  stock?: string,
): Promise<ProductPage> {
  const qp = new URLSearchParams({ page: String(page), pageSize: '50' });
  if (q !== '') qp.set('q', q);
  if (site !== undefined && site !== 'all') qp.set('site', site);
  if (flags !== undefined && flags.length > 0) qp.set('flags', flags.join(','));
  if (stock !== undefined && stock !== 'all') qp.set('stock', stock);
  return fetchJson(`/api/v1/products?${qp.toString()}`);
}

export interface SageExportItem {
  readonly id: number;
  readonly createdAt: string;
  readonly formatKey: string;
  readonly mode?: 'full' | 'delta' | 'dry';
  readonly rowCount: number;
  readonly includedCount: number;
  readonly rejectedCount: number;
  readonly bundleExcluded: number;
  readonly vatPercent: number;
  readonly csvFile: string | null;
  readonly xlsxFile?: string | null;
  readonly rejectsFile?: string | null;
  readonly excludedFile?: string | null;
}

export interface SageDeltaStats {
  readonly lastExport: {
    readonly id: number;
    readonly createdAt: string;
    readonly mode: string;
    readonly includedCount: number;
  } | null;
  readonly lastCleanExport?: {
    readonly id: number;
    readonly createdAt: string;
    readonly mode: string;
    readonly includedCount: number;
  } | null;
  readonly totalEligible: number;
  readonly deltaCount: number;
  readonly withBarcodeCount: number;
  readonly withoutBarcodeCount: number;
  readonly withPurchasePriceCount?: number;
  readonly withLayer2Count?: number;
  readonly readyForSageCount?: number;
  readonly readyForSageDeltaCount?: number;
}

export function fetchSageExports(): Promise<readonly SageExportItem[]> {
  return fetchJson('/api/v1/sage-exports');
}

export function fetchSageDeltaStats(): Promise<SageDeltaStats> {
  return fetchJson('/api/v1/sage-exports/delta-stats');
}

export function generateSageExport(params?: {
  limit?: number;
  mode?: 'full' | 'delta';
  onlyWithBarcode?: boolean;
  onlyClean?: boolean;
  formatKey?: string;
}): Promise<SageExportItem> {
  return fetchJson('/api/v1/sage-exports', {
    method: 'POST',
    body: JSON.stringify(params ?? {}),
  });
}

export interface ShippingSummary {
  readonly totalShiparonParcels: number;
  readonly totalShiparonAmount: number;
  readonly matchedCount: number;
  readonly matchedCarrierAmount: number;
  readonly matchedShiparonAmount: number;
  readonly ghostedCount: number;
  readonly ghostedAmount: number;
  readonly unassignedCount: number;
  readonly unassignedAmount: number;
  readonly priceMismatchCount: number;
  readonly priceMismatchTotalDiff: number;
  readonly underpaidCount?: number;
  readonly underpaidDeficit?: number;
  readonly overpaidCount?: number;
  readonly overpaidSurplus?: number;
  readonly exactPaidCount?: number;
  readonly paidCount: number;
  readonly paidAmount: number;
  readonly adminApprovedCount?: number;
  readonly adminApprovedAmount?: number;
  readonly carrierPaidPendingCount?: number;
  readonly carrierPaidPendingAmount?: number;
  readonly unpaidCount?: number;
  readonly unpaidAmount?: number;
  readonly unverifiedCount?: number;
  /** cancelled (etat 6) kept VISIBLE for fraud review */
  readonly cancelledCount?: number;
  readonly cancelledAmount?: number;
  /** cancelled AND paid â€” the steal pattern, alarm */
  readonly cancelledPaidCount?: number;
  readonly cancelledPaidAmount?: number;
}

export interface ReconciledParcelItem {
  readonly codeBarre: string;
  readonly facture?: string | null; // Woo order link
  readonly msg?: string | null; // middleware Notes = Woo order number (shop-manager foundation)
  readonly status: string;
  readonly triggeredBy?: string | null;
  readonly clientName: string | null;
  readonly clientPhone: string | null;
  readonly location: string | null;
  readonly date: string | null;
  readonly shiparonPrice: number | null;
  readonly carrierPrice: number | null;
  readonly priceDiff: number | null;
  readonly settlementAmount?: number | null;
  readonly mismatchType?: 'exact' | 'underpaid' | 'overpaid' | null;
  readonly shiparonEtat: number | null;
  readonly shiparonEtatLabel: string | null;
  readonly isPaid: boolean;
  readonly carrier: string | null;
  readonly motif: string | null;
  readonly adminPaymentStatus?: 'unpaid' | 'carrier_paid' | 'approved';
  readonly paymentApprovedAt?: string | null;
  readonly paymentApprovedBy?: string | null;
  readonly paymentBankRef?: string | null;
  readonly settlementBatch?: string | null;
  readonly carrierStatus?: string | null;
  readonly carrierPaye?: number | null;
  readonly idRunsheet?: number | null;
  readonly runsheetDate?: string | null;
  readonly runsheetLivreur?: string | null;
  readonly runsheetEtat?: number | null;
  readonly runsheetAgence?: string | null;
}

export interface ShippingSyncInfo {
  readonly id: number;
  readonly status: string;
  readonly triggeredBy?: string | null;
  readonly rowCount: number;
  readonly totalRows?: number | null;
  readonly progressStage?: string | null;
  readonly durationMs: number | null;
  readonly errorMessage?: string | null;
  readonly createdAt: string;
}

export interface ShippingSummaryResponse {
  readonly summary: ShippingSummary;
  readonly latestSync: ShippingSyncInfo | null;
  readonly latestImport: {
    readonly id: number;
    readonly filename: string;
    readonly rowCount: number;
    readonly totalAmount: number;
    readonly importedAt: string;
  } | null;
}

export interface ShippingParcelsResponse {
  readonly total: number;
  readonly page: number;
  readonly limit: number;
  readonly totalPages: number;
  readonly parcels: readonly ReconciledParcelItem[];
}

export function fetchShippingSummary(params?: {
  carrier?: string | undefined;
  startDate?: string | undefined;
  endDate?: string | undefined;
}): Promise<ShippingSummaryResponse> {
  const q = new URLSearchParams();
  if (params?.carrier) q.set('carrier', params.carrier);
  if (params?.startDate) q.set('startDate', params.startDate);
  if (params?.endDate) q.set('endDate', params.endDate);
  const qs = q.toString();
  return fetchJson(`/api/v1/shipping/reconciliation/summary${qs ? `?${qs}` : ''}`);
}

export function fetchShippingParcels(params?: {
  carrier?: string | undefined;
  startDate?: string | undefined;
  endDate?: string | undefined;
  status?: string | undefined;
  shiparonEtat?: number | string | undefined;
  paymentStatus?: string | undefined;
  search?: string | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}): Promise<ShippingParcelsResponse> {
  const q = new URLSearchParams();
  if (params?.carrier) q.set('carrier', params.carrier);
  if (params?.startDate) q.set('startDate', params.startDate);
  if (params?.endDate) q.set('endDate', params.endDate);
  if (params?.status) q.set('status', params.status);
  if (params?.shiparonEtat !== undefined && params?.shiparonEtat !== null && params?.shiparonEtat !== '' && params?.shiparonEtat !== 'all') {
    q.set('shiparonEtat', String(params.shiparonEtat));
  }
  if (params?.paymentStatus) q.set('paymentStatus', params.paymentStatus);
  if (params?.search) q.set('search', params.search);
  if (params?.page) q.set('page', String(params.page));
  if (params?.limit) q.set('limit', String(params.limit));
  const qs = q.toString();
  return fetchJson(`/api/v1/shipping/reconciliation/parcels${qs ? `?${qs}` : ''}`);
}

export interface CarrierAnalyticsItem {
  readonly carrier: string;
  readonly total: number;
  readonly delivered: number;
  readonly returns: number;
  readonly inTransit: number;
  readonly deliveryRate: number;
  readonly returnRate: number;
  readonly totalCod: number;
  readonly deliveredCod: number;
}

export interface StatusDistributionItem {
  readonly etat: number;
  readonly label: string;
  readonly count: number;
  readonly totalCod: number;
}

export interface MonthlyVolumeItem {
  readonly month: string;
  readonly count: number;
  readonly delivered: number;
  readonly returns: number;
  readonly totalCod: number;
  readonly deliveredCod: number;
}

export interface TopDestinationItem {
  readonly gouvernerat: string;
  readonly count: number;
  readonly totalCod: number;
}

export interface AnalyticsMeta {
  readonly startDate: string | null;
  readonly endDate: string | null;
  readonly ytdYear: number;
  readonly ytdStart: string;
  readonly ytdEnd: string;
  readonly assignedOnly: boolean;
  readonly totalInScope: number;
  readonly assignedInScope: number;
  readonly unassignedInScope: number;
  /** Parcels checked at least once against the live carrier API (carrierLastCheckAt). */
  readonly jetpackChecked: number;
  /** Delivered per middleware mirror (etat 2/10/32). Overlaps with carrier API. */
  readonly deliveredViaMiddleware: number;
  /** Delivered per live carrier API in our DB (carrierStatus 'livr*'). */
  readonly deliveredViaCarrierApi: number;
}

export interface ShippingAnalyticsResponse {
  readonly carriers: readonly CarrierAnalyticsItem[];
  readonly statusDistribution: readonly StatusDistributionItem[];
  readonly monthlyVolume: readonly MonthlyVolumeItem[];
  readonly topDestinations: readonly TopDestinationItem[];
  /** Exact Janâ†’selected-end monthly COD series (assigned parcels only). */
  readonly ytdFinancial: readonly MonthlyVolumeItem[];
  readonly meta: AnalyticsMeta;
}

export function fetchShippingAnalytics(params?: {
  carrier?: string;
  startDate?: string;
  endDate?: string;
}): Promise<ShippingAnalyticsResponse> {
  const q = new URLSearchParams();
  if (params?.carrier && params.carrier !== 'all') q.set('carrier', params.carrier);
  if (params?.startDate) q.set('startDate', params.startDate);
  if (params?.endDate) q.set('endDate', params.endDate);
  const qs = q.toString();
  return fetchJson(`/api/v1/shipping/analytics${qs ? `?${qs}` : ''}`);
}

// One courier tour (grouped by middleware id_runsheet) + its packages.
export interface RunsheetTour {
  readonly idRunsheet: number;
  readonly tourDate: string | null;
  readonly livreurRaw: string | null;
  readonly livreurNom: string | null;
  readonly livreurTel: string | null;
  readonly matricule: string | null;
  readonly agence: string | null;
  readonly km: number;
  readonly packageCount: number;
  readonly totalCod: number;
  readonly deliveredCod: number;
  readonly deliveredCount: number;
  readonly deliveryFee: number;
  readonly netAmount: number;
  readonly unitFee: number;
  readonly validated: boolean;
  readonly verifier: boolean;
}

export interface RunsheetLivreurOption {
  readonly id: string;
  readonly nom: string;
  readonly matricule: string | null;
}

export interface RunsheetSummaryStats {
  readonly totalTours: number;
  readonly totalPackages: number;
  readonly totalCod: number;
  readonly totalDeliveredCod: number;
  readonly totalDelivered: number;
  readonly totalDeliveryFee: number;
  readonly totalNetAmount: number;
  readonly totalValidated: number;
  readonly totalInProgress: number;
}

export interface ShippingRunsheetsResponse {
  readonly total: number;
  readonly page: number;
  readonly limit: number;
  readonly totalPages: number;
  readonly tours: readonly RunsheetTour[];
  readonly agences: readonly string[];
  readonly livreurs?: readonly RunsheetLivreurOption[];
  readonly couriersList?: ReadonlyArray<{
    key: string;
    label: string;
    count: number;
    runsheetsCount: number;
    type: 'presta' | 'livreur';
  }>;
  readonly summary?: RunsheetSummaryStats;
  readonly years?: readonly number[];
  readonly unassignedCount: number;
  readonly availableStatuses?: ReadonlyArray<{
    readonly id: number;
    readonly label: string;
    readonly count: number;
  }>;
  readonly availableWooStatuses?: ReadonlyArray<{
    readonly slug: string;
    readonly label: string;
    readonly count: number;
  }>;
}

export function fetchShippingRunsheets(params?: {
  livreur?: string | undefined;
  agence?: string | undefined;
  status?: 'all' | 'validated' | 'in_progress' | undefined;
  statuses?: string | undefined;
  wooStatuses?: string | undefined;
  year?: string | undefined;
  month?: string | undefined;
  unitFee?: number | undefined;
  startDate?: string | undefined;
  endDate?: string | undefined;
  search?: string | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}): Promise<ShippingRunsheetsResponse> {
  const q = new URLSearchParams();
  if (params?.livreur && params.livreur !== 'all') q.set('livreur', params.livreur);
  if (params?.agence && params.agence !== 'all') q.set('agence', params.agence);
  if (params?.status && params.status !== 'all') q.set('status', params.status);
  if (params?.statuses && params.statuses !== 'all') q.set('statuses', params.statuses);
  if (params?.wooStatuses && params.wooStatuses !== 'all') q.set('wooStatuses', params.wooStatuses);
  if (params?.year && params.year !== 'all') q.set('year', params.year);
  if (params?.month && params.month !== 'all' && params.month !== '0') q.set('month', params.month);
  if (params?.unitFee && params.unitFee > 0) q.set('unitFee', String(params.unitFee));
  if (params?.startDate) q.set('startDate', params.startDate);
  if (params?.endDate) q.set('endDate', params.endDate);
  if (params?.search) q.set('search', params.search);
  if (params?.page) q.set('page', String(params.page));
  if (params?.limit) q.set('limit', String(params.limit));
  const qs = q.toString();
  return fetchJson(`/api/v1/shipping/runsheets${qs ? `?${qs}` : ''}`);
}

export function getRunsheetExportUrl(params?: {
  livreur?: string | undefined;
  agence?: string | undefined;
  status?: 'all' | 'validated' | 'in_progress' | undefined;
  statuses?: string | undefined;
  wooStatuses?: string | undefined;
  year?: string | undefined;
  month?: string | undefined;
  unitFee?: number | undefined;
  startDate?: string | undefined;
  endDate?: string | undefined;
  search?: string | undefined;
}): string {
  const q = new URLSearchParams();
  if (params?.livreur && params.livreur !== 'all') q.set('livreur', params.livreur);
  if (params?.agence && params.agence !== 'all') q.set('agence', params.agence);
  if (params?.status && params.status !== 'all') q.set('status', params.status);
  if (params?.statuses && params.statuses !== 'all') q.set('statuses', params.statuses);
  if (params?.wooStatuses && params.wooStatuses !== 'all') q.set('wooStatuses', params.wooStatuses);
  if (params?.year && params.year !== 'all') q.set('year', params.year);
  if (params?.month && params.month !== 'all' && params.month !== '0') q.set('month', params.month);
  if (params?.unitFee && params.unitFee > 0) q.set('unitFee', String(params.unitFee));
  if (params?.startDate) q.set('startDate', params.startDate);
  if (params?.endDate) q.set('endDate', params.endDate);
  if (params?.search) q.set('search', params.search);
  const qs = q.toString();
  return `/api/v1/shipping/runsheets/export.xlsx${qs ? `?${qs}` : ''}`;
}

export interface RunsheetDetailResponse {
  readonly header: RunsheetTour;
  readonly total: number;
  readonly page: number;
  readonly limit: number;
  readonly totalPages: number;
  readonly parcels: readonly ReconciledParcelItem[];
}

export function fetchShippingRunsheetDetail(
  idRunsheet: number,
  params?: { search?: string | undefined; page?: number | undefined; limit?: number | undefined },
): Promise<RunsheetDetailResponse> {
  const q = new URLSearchParams();
  if (params?.search) q.set('search', params.search);
  if (params?.page) q.set('page', String(params.page));
  if (params?.limit) q.set('limit', String(params.limit));
  const qs = q.toString();
  return fetchJson(`/api/v1/shipping/runsheets/${idRunsheet}${qs ? `?${qs}` : ''}`);
}

export interface ShippingCaKpis {
  readonly deliveredCount: number;
  readonly deliveredCod: number;
  readonly returnedCount: number;
  readonly returnedCod: number;
  readonly inTransitCount: number;
  readonly inTransitCod: number;
  readonly totalParcels: number;
  readonly deliveryRatePct: number;
  readonly deliveryPriceUnitHt: number;
  readonly deliveryPriceUnitTtc?: number;
  readonly vatRate: number;
  readonly estimatedFeesHt: number;
  readonly estimatedFeesTtc: number;
  readonly netPayout: number;
  readonly paidCount: number;
  readonly paidCod: number;
  readonly unpaidCount: number;
  readonly unpaidCod: number;
}

export interface ShippingCaDailyRow {
  readonly date: string;
  readonly deliveredCount: number;
  readonly deliveredCod: number;
  readonly returnedCount: number;
  readonly inTransitCount: number;
  readonly feesHt: number;
  readonly feesTtc?: number;
  readonly netPayout: number;
}

export interface ShippingCaCourierOption {
  readonly key: string;
  readonly label: string;
  readonly name: string;
  readonly type: 'presta' | 'livreur' | 'excel';
  readonly count: number;
}

export interface ShippingCaParcelItem {
  readonly id: number;
  readonly source: 'shiparon' | 'excel';
  readonly codeBarre: string;
  readonly orderRef: string | null;
  readonly clientNom: string | null;
  readonly clientTel: string | null;
  readonly destination: string | null;
  readonly dateEvent: string | null;
  readonly dateAdd: string | null;
  readonly status: 'delivered' | 'returned' | 'in_transit' | 'other';
  readonly statusLabel: string;
  readonly prixCod: number;
  readonly feeHt: number;
  readonly feeTtc?: number;
  readonly isPaid: boolean;
  readonly courierName: string;
  readonly wooStatus?: string | null;
  readonly wooStatusLabel?: string | null;
}

export interface ShippingCaWooStatusOption {
  readonly slug: string;
  readonly label: string;
  readonly count: number;
}

export interface ShippingCaStatusOption {
  readonly id: number;
  readonly label: string;
  readonly count: number;
}

export interface ShippingCaResponse {
  readonly carrier: string;
  readonly carrierLabel: string;
  readonly carrierType: string;
  readonly period: {
    readonly startDate: string;
    readonly endDate: string;
  };
  readonly kpis: ShippingCaKpis;
  readonly dailyBreakdown: readonly ShippingCaDailyRow[];
  readonly couriersList: readonly ShippingCaCourierOption[];
  readonly availableStatuses?: readonly ShippingCaStatusOption[];
  readonly availableWooStatuses?: readonly ShippingCaWooStatusOption[];
  readonly selectedWooStatuses?: readonly string[] | null;
  readonly selectedStatuses?: readonly number[] | null;
  readonly customFeeTtc?: number | null;
  readonly parcels: {
    readonly total: number;
    readonly page: number;
    readonly limit: number;
    readonly totalPages: number;
    readonly items: readonly ShippingCaParcelItem[];
  };
}

export function fetchShippingCa(params?: {
  carrier?: string | undefined;
  carrierType?: 'all' | 'presta' | 'livreur' | undefined;
  startDate?: string | undefined;
  endDate?: string | undefined;
  page?: number | undefined;
  limit?: number | undefined;
  status?: string | undefined;
  statuses?: string | undefined;
  wooStatuses?: string | undefined;
  search?: string | undefined;
  customFeeTtc?: number | string | undefined;
}): Promise<ShippingCaResponse> {
  const q = new URLSearchParams();
  if (params?.carrier) q.set('carrier', params.carrier);
  if (params?.carrierType) q.set('carrierType', params.carrierType);
  if (params?.startDate) q.set('startDate', params.startDate);
  if (params?.endDate) q.set('endDate', params.endDate);
  if (params?.page) q.set('page', String(params.page));
  if (params?.limit) q.set('limit', String(params.limit));
  if (params?.status && params.status !== 'all') q.set('status', params.status);
  if (params?.statuses) q.set('statuses', params.statuses);
  if (params?.wooStatuses) q.set('wooStatuses', params.wooStatuses);
  if (params?.search) q.set('search', params.search);
  if (params?.customFeeTtc !== undefined && params?.customFeeTtc !== '') {
    q.set('customFeeTtc', String(params.customFeeTtc));
  }
  const qs = q.toString();
  return fetchJson('/api/v1/shipping/ca' + (qs ? '?' + qs : ''));
}


export interface PublicTrackingEvent {
  readonly date: string;
  readonly title: string;
  readonly description: string | null;
  readonly icon: string;
}

export interface PublicTrackingResponse {
  readonly codeBarre: string;
  readonly orderNumber: string | null;
  readonly carrier: string;
  readonly recipientName: string | null;
  readonly destination: string;
  readonly status: 'preparing' | 'in_transit' | 'out_for_delivery' | 'delivered' | 'return' | 'cancelled';
  readonly statusLabel: string;
  readonly dispatchedAt: string | null;
  readonly lastUpdatedAt: string | null;
  readonly isDelivered: boolean;
  readonly isReturn: boolean;
  readonly isCancelled: boolean;
  readonly events: readonly PublicTrackingEvent[];
  readonly searchedByPhone?: boolean;
  readonly relatedParcels?: ReadonlyArray<{
    readonly dateAdd: string | null;
    readonly etatLabel: string;
    readonly isCurrent?: boolean;
    readonly codeBarre?: string;
    readonly facture?: string | null;
  }>;
}

export function fetchPublicTracking(code: string): Promise<PublicTrackingResponse> {
  return fetchJson(`/api/v1/public/tracking/${encodeURIComponent(code)}`);
}

export function testShiparonConnection(): Promise<{
  ok: boolean;
  host: string;
  database: string;
  totalOrders: number;
  latencyMs: number;
  error?: string;
}> {
  return fetchJson('/api/v1/shipping/test-connection');
}

export function triggerShiparonSync(
  params?: { readonly startDate?: string; readonly fullHistory?: boolean } | string,
): Promise<{
  ok: boolean;
  syncId: number;
  rowCount: number;
  durationMs: number;
}> {
  return fetchJson('/api/v1/shipping/sync', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(typeof params === 'string' ? { startDate: params } : (params ?? {})),
  });
}

export async function uploadCarrierCsv(file: File): Promise<{
  ok: boolean;
  importId: number;
  filename: string;
  rowCount: number;
  totalAmount: number;
}> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch('/api/v1/shipping/carrier-file', {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `HTTP ${response.status}`);
  }
  return response.json();
}

export interface ShippingSyncHistoryItem {
  id: number;
  status: string;
  triggeredBy: string | null;
  periodStart: string | null;
  rowCount: number;
  totalRows?: number | null;
  progressStage?: string | null;
  durationMs: number | null;
  error?: string | null;
  errorMessage?: string | null;
  createdAt: string;
}

export interface ShippingImportHistoryItem {
  id: number;
  filename: string;
  kind: string;
  rowCount: number;
  createdAt: string;
}

export function fetchShippingHistory(): Promise<{
  syncs: readonly ShippingSyncHistoryItem[];
  imports: readonly ShippingImportHistoryItem[];
}> {
  return fetchJson('/api/v1/shipping/history');
}

export function fetchShippingCarriers(): Promise<{
  carriers: Array<{
    carrier: string;
    rawPresta: string | null;
    kind?: 'carrier' | 'livreur' | 'unassigned';
    livreurId?: number;
    count: number;
    totalAmount: number;
  }>;
}> {
  return fetchJson('/api/v1/shipping/carriers');
}

export function fetchPaymentSummary(carrier?: string): Promise<{
  totalDeliveredCount: number;
  totalDeliveredAmount: number;
  carrierPaidCount: number;
  carrierPaidAmount: number;
  approvedCount: number;
  approvedAmount: number;
  unpaidCount: number;
  unpaidAmount: number;
}> {
  const qs = carrier && carrier !== 'all' ? `?carrier=${encodeURIComponent(carrier)}` : '';
  return fetchJson(`/api/v1/shipping/payments/summary${qs}`);
}

export function fetchPaymentSettlements(): Promise<{
  settlements: Array<{
    id: number;
    carrierName: string;
    settlementDate: string | null;
    filename: string | null;
    totalAmount: number;
    feesAmount: number | null;
    netAmount: number | null;
    parcelCount: number;
    status: string;
    approvedBy: string | null;
    approvedAt: string | null;
    bankRef: string | null;
    notes: string | null;
    importedAt: string;
  }>;
}> {
  return fetchJson('/api/v1/shipping/payments/settlements');
}

export function approvePayment(body: {
  codes?: string[] | undefined;
  settlementId?: number | undefined;
  bankRef?: string | undefined;
  notes?: string | undefined;
}): Promise<{ ok: boolean; updatedCount: number; approvedBy: string; approvedAt: string }> {
  return fetchJson('/api/v1/shipping/payments/approve', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function uploadSettlementCsv(file: File): Promise<{
  ok: boolean;
  settlementId: number;
  filename: string;
  settlementDate: string;
  parcelCount: number;
  matchedInShiparon: number;
  totalAmount: number;
}> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch('/api/v1/shipping/settlement-file', {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `HTTP ${response.status}`);
  }
  return response.json();
}

export function syncJetpackTrackApi(limit = 25000, unverifiedOnly = false): Promise<{
  ok: boolean;
  totalChecked: number;
  updatedCount: number;
  ghostCount: number;
  paidCount: number;
}> {
  return fetchJson('/api/v1/shipping/jetpack/track-api', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ limit, unverifiedOnly }),
  });
}

/** Enqueue the worker job that fetches the Jetpack payment file from their
 *  portal and applies it (ghosts resolved to carrier_paid). */
export function triggerJetpackPaymentsFetch(): Promise<{ ok: boolean; queued: boolean; jobId: string | null }> {
  return fetchJson('/api/v1/shipping/jetpack/payments-fetch', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({}),
  });
}


export interface ParcelTimelineEvent {
  readonly id: number;
  readonly shiparonId: number;
  readonly etat: number;
  readonly etatLabel: string;
  readonly dt: string;
  readonly magasin: string | null;
  readonly livreur: string | null;
  readonly motif: string | null;
}

export interface ParcelTimelineRunsheet {
  readonly id: number;
  readonly shiparonRunsheetId: number;
  readonly codeBarre: string;
  readonly livreur: string | null;
  readonly matricule: string | null;
  readonly dt: string | null;
  readonly idRunsheet: number | null;
  readonly agence: string | null;
}

export interface ParcelTimelineResponse {
  readonly barcode: string;
  readonly colis: {
    readonly id: number;
    readonly shiparonId: number | null;
    readonly codeBarre: string;
    readonly etat: number;
    readonly etatLabel: string;
    readonly dateAdd: string | null;
    readonly presta: string | null;
    readonly prix: number;
  } | null;
  readonly historique: readonly ParcelTimelineEvent[];
  readonly runsheet: readonly ParcelTimelineRunsheet[];
}

export function fetchParcelTimeline(barcode: string): Promise<ParcelTimelineResponse> {
  return fetchJson(`/api/v1/shipping/parcels/${encodeURIComponent(barcode)}/timeline`);
}

// ---------------------------------------------------------------------------
// Logistics Management Configuration & Specialized Workspaces
// ---------------------------------------------------------------------------

export interface LogisticsConfig {
  readonly hiddenEtats: number[];
  readonly hiddenCarriers: string[];
  readonly hiddenLivreurs: number[];
  readonly excludePendingFromReconciliation: boolean;
  readonly returnAnomalyDays: number;
  readonly returnStartDate?: string | null;
}

export function fetchLogisticsConfig(): Promise<{ config: LogisticsConfig }> {
  return fetchJson('/api/v1/shipping/config');
}

export function updateLogisticsConfig(
  body: Partial<LogisticsConfig>,
): Promise<{ ok: boolean; config: LogisticsConfig }> {
  return fetchJson('/api/v1/shipping/config', {
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export interface EtatRosterItem {
  readonly code: number;
  readonly label: string;
  readonly count: number;
}

export function fetchEtatsRoster(): Promise<{ etats: readonly EtatRosterItem[] }> {
  return fetchJson('/api/v1/shipping/etats-roster');
}

export interface LivreurRosterItem {
  readonly id: number;
  readonly livreurId: number;
  readonly nom: string | null;
  readonly tel: string | null;
  readonly matricule: string | null;
  readonly prestation: string | null;
}

export interface LivreursRosterResponse {
  readonly carriers: ReadonlyArray<{ name: string; count: number }>;
  readonly livreurs: readonly LivreurRosterItem[];
}

export function fetchLivreursRoster(): Promise<LivreursRosterResponse> {
  return fetchJson('/api/v1/shipping/livreurs-roster');
}

export interface ExchangesResponse {
  readonly parcels: readonly ReconciledParcelItem[];
  readonly totalCount: number;
  readonly page: number;
  readonly limit: number;
  readonly totalPages: number;
  readonly kpis: {
    readonly total: number;
    readonly delivered: number;
    readonly inTransit: number;
    readonly totalAmount: number;
  };
}

export function fetchExchanges(params?: {
  carrier?: string;
  search?: string;
  page?: number;
  limit?: number;
}): Promise<ExchangesResponse> {
  const query = new URLSearchParams();
  if (params?.carrier && params.carrier !== 'all') query.set('carrier', params.carrier);
  if (params?.search) query.set('search', params.search);
  if (params?.page) query.set('page', String(params.page));
  if (params?.limit) query.set('limit', String(params.limit));
  const qs = query.toString() ? `?${query.toString()}` : '';
  return fetchJson(`/api/v1/shipping/echanges${qs}`);
}

export interface ExchangeDetailResponse {
  readonly parcel: ReconciledParcelItem;
  readonly wooOrder: {
    readonly id: number;
    readonly number: string;
    readonly status: string;
    readonly customerName: string | null;
    readonly billingPhone: string | null;
    readonly lineItems: ReadonlyArray<{ sku: string | null; name: string | null; qty: number; price: number | null }> | null;
    readonly total: number | null;
  } | null;
  readonly exchangeReturn: {
    readonly rawNote: string;
    readonly product: {
      readonly name: string;
      readonly sku: string | null;
      readonly brand: string | null;
      readonly imageUrl: string | null;
      readonly price: number | null;
    } | null;
  };
}

export function fetchExchangeDetail(barcode: string): Promise<ExchangeDetailResponse> {
  return fetchJson(`/api/v1/shipping/echanges/${encodeURIComponent(barcode)}/detail`);
}

export interface ReturnAnomaliesResponse {
  readonly parcels: ReadonlyArray<
    ReconciledParcelItem & {
      readonly daysInReturn: number;
      readonly isAnomaly: boolean;
    }
  >;
  readonly totalCount: number;
  readonly page: number;
  readonly limit: number;
  readonly totalPages: number;
  readonly anomalyDaysThreshold: number;
  readonly returnStartDate?: string | null;
  readonly kpis: {
    readonly totalReturns: number;
    readonly agencyReturns: number;
    readonly overdueAgencyReturns: number;
    readonly overdueAmount: number;
    readonly receivedAtMapara: number;
  };
}

export function fetchReturnsAnomalies(params?: {
  carrier?: string;
  anomalyOnly?: boolean;
  statusFilter?: 'all' | 'anomalies' | 'received' | 'pending';
  search?: string;
  page?: number;
  limit?: number;
}): Promise<ReturnAnomaliesResponse> {
  const query = new URLSearchParams();
  if (params?.carrier && params.carrier !== 'all') query.set('carrier', params.carrier);
  if (params?.statusFilter) query.set('statusFilter', params.statusFilter);
  else if (params?.anomalyOnly) query.set('anomalyOnly', 'true');
  if (params?.search) query.set('search', params.search);
  if (params?.page) query.set('page', String(params.page));
  if (params?.limit) query.set('limit', String(params.limit));
  const qs = query.toString() ? `?${query.toString()}` : '';
  return fetchJson(`/api/v1/shipping/returns/anomalies${qs}`);
}

export function scanReturnBarcode(
  codeBarre: string,
  notes?: string,
): Promise<{
  ok: boolean;
  alreadyReceived: boolean;
  parcel: ReconciledParcelItem;
  message: string;
}> {
  return fetchJson('/api/v1/shipping/returns/scan', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ codeBarre, notes }),
  });
}

export function unscanReturnBarcode(codeBarre: string): Promise<{
  ok: boolean;
  parcel: ReconciledParcelItem;
  message: string;
}> {
  return fetchJson('/api/v1/shipping/returns/unscan', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ codeBarre }),
  });
}

export function fetchReturnsScannedToday(): Promise<{
  count: number;
  parcels: readonly ReconciledParcelItem[];
}> {
  return fetchJson('/api/v1/shipping/returns/scanned-today');
}

export interface CancellationsResponse {
  readonly parcels: ReadonlyArray<
    ReconciledParcelItem & {
      readonly isSuspiciousPaid: boolean;
    }
  >;
  readonly totalCount: number;
  readonly page: number;
  readonly limit: number;
  readonly totalPages: number;
  readonly kpis: {
    readonly totalCancelled: number;
    readonly totalAmount: number;
    readonly suspiciousPaidCount: number;
    readonly suspiciousPaidAmount: number;
  };
  readonly topMotifs: ReadonlyArray<{
    readonly motif: string;
    readonly count: number;
  }>;
}

export function fetchCancellations(params?: {
  carrier?: string;
  onlySuspiciousPaid?: boolean;
  search?: string;
  page?: number;
  limit?: number;
}): Promise<CancellationsResponse> {
  const query = new URLSearchParams();
  if (params?.carrier && params.carrier !== 'all') query.set('carrier', params.carrier);
  if (params?.onlySuspiciousPaid) query.set('onlySuspiciousPaid', 'true');
  if (params?.search) query.set('search', params.search);
  if (params?.page) query.set('page', String(params.page));
  if (params?.limit) query.set('limit', String(params.limit));
  const qs = query.toString() ? `?${query.toString()}` : '';
  return fetchJson(`/api/v1/shipping/cancellations${qs}`);
}


// ============================================================================
// B2B Procurement & Wholesaler Reconciliation Types & Methods
// ============================================================================

export interface B2BWholesalerOfferDto {
  readonly offerId: number;
  readonly sourceKey: string;
  readonly sourceLabel: string;
  readonly externalRef: string;
  readonly referenceRaw: string | null;
  readonly nameRaw: string;
  readonly brandRaw: string | null;
  readonly priceHt: number | null;
  readonly priceTtc: number | null;
  readonly vatRate: number | null;
  readonly isPromo?: boolean;
  readonly promoPercent?: number | null;
  readonly promoBuyQty: number | null;
  readonly promoFreeQty: number | null;
  readonly unitPriceRealHt: number | null;
  readonly inStock: boolean | null;
  readonly url: string | null;
  readonly fetchedAt: string;
  readonly priceHistoryCount: number;
  readonly isManualMatch?: boolean;
}

export interface B2BReconciliationItemDto {
  readonly product: {
    readonly id: number;
    readonly sku: string;
    readonly name: string;
    readonly brand: string | null;
    readonly gtin: string | null;
    readonly image: string | null;
    readonly sellingPriceTtc: number | null;
    readonly sellingPriceHt: number | null;
    readonly currentVatRate: number | null;
    readonly currentPurchasePriceHt: number | null;
    readonly currentPurchaseSourceKey: string | null;
    readonly finalEanConfirmed?: boolean;
    readonly finalEanConfirmedAt?: string | null;
  };
  readonly wholesalerOffers: readonly B2BWholesalerOfferDto[];
  readonly buyBox: {
    readonly sourceKey: string;
    readonly sourceLabel: string;
    readonly priceHt: number;
    readonly isPromo?: boolean;
    readonly promoPercent?: number | null;
    readonly promoBuyQty: number | null;
    readonly promoFreeQty: number | null;
    readonly unitPriceRealHt: number | null;
    readonly inStock: boolean | null;
    readonly offerId: number;
  } | null;
  readonly margin: {
    readonly grossMarginAmount: number | null;
    /** Markup ON the purchase price (client target: 20%), not a selling margin. */
    readonly grossMarkupPercent: number | null;
    readonly status: 'below_target' | 'on_target' | 'above_target' | 'unknown';
  };
  readonly vatStatus: {
    readonly currentVatRate: number | null;
    readonly wholesalerVatRates: readonly number[];
    /** true only when a wholesaler offer actually carried a rate */
    readonly vatVerified: boolean;
    readonly hasVatMismatch: boolean;
    readonly vatMismatchNote: string | null;
  };
}

export interface B2BReconciliationResponse {
  readonly items: readonly B2BReconciliationItemDto[];
  readonly pagination: {
    readonly total: number;
    readonly page: number;
    readonly limit: number;
    readonly totalPages: number;
  };
  readonly stats: {
    readonly totalProducts: number;
    readonly matchedWithWholesalerCount: number;
    readonly missingPurchasePriceCount?: number;
    readonly approvedGtinCount?: number;
    readonly pendingLayer2Count?: number;
    readonly vatDiscrepanciesCount: number;
    readonly portals: readonly {
      readonly key: string;
      readonly label: string;
      readonly totalOffers: number;
      readonly lastCrawl: {
        readonly status: string;
        readonly startedAt: string;
        readonly finishedAt: string | null;
        readonly offersCreated: number;
      } | null;
    }[];
  };
}

export interface B2BNewProductDto {
  readonly id: number;
  readonly sourceKey: string;
  readonly sourceLabel: string;
  readonly externalRef: string;
  readonly referenceRaw: string | null;
  readonly gtin: string;
  readonly name: string;
  readonly brand: string | null;
  readonly priceHt: number | null;
  readonly priceTtc: number | null;
  readonly vatRate: number | null;
  readonly inStock: boolean | null;
  readonly url: string | null;
  readonly image: string | null;
  readonly fetchedAt: string;
}

export interface B2BNewProductsResponse {
  readonly items: readonly B2BNewProductDto[];
  readonly pagination: {
    readonly total: number;
    readonly page: number;
    readonly limit: number;
    readonly totalPages: number;
  };
  readonly countsBySource: Record<string, number>;
}

export function fetchB2BReconciliation(params?: {
  page?: number | undefined;
  limit?: number | undefined;
  q?: string | undefined;
  brand?: string | undefined;
  vatDiscrepancyOnly?: boolean | undefined;
  hasWholesalerOffer?: boolean | undefined;
  missingPurchasePriceOnly?: boolean | undefined;
  eanApprovedOnly?: boolean | undefined;
  sortBy?: string | undefined;
}): Promise<B2BReconciliationResponse> {
  const query = new URLSearchParams();
  if (params?.page) query.set('page', String(params.page));
  if (params?.limit) query.set('limit', String(params.limit));
  if (params?.q) query.set('q', params.q);
  if (params?.brand) query.set('brand', params.brand);
  if (params?.vatDiscrepancyOnly) query.set('vatDiscrepancyOnly', 'true');
  if (params?.hasWholesalerOffer) query.set('hasWholesalerOffer', 'true');
  if (params?.missingPurchasePriceOnly) query.set('missingPurchasePriceOnly', 'true');
  if (params?.eanApprovedOnly) query.set('eanApprovedOnly', 'true');
  if (params?.sortBy) query.set('sortBy', params.sortBy);
  const qs = query.toString() ? `?${query.toString()}` : '';
  return fetchJson(`/api/v1/b2b/price-vat-reconciliation${qs}`);
}

export function fetchB2BNewProducts(params?: {
  page?: number | undefined;
  limit?: number | undefined;
  sourceKey?: string | undefined;
  brand?: string | undefined;
  inStockOnly?: boolean | undefined;
  q?: string | undefined;
}): Promise<B2BNewProductsResponse> {
  const query = new URLSearchParams();
  if (params?.page) query.set('page', String(params.page));
  if (params?.limit) query.set('limit', String(params.limit));
  if (params?.sourceKey && params.sourceKey !== 'all') query.set('sourceKey', params.sourceKey);
  if (params?.brand) query.set('brand', params.brand);
  if (params?.inStockOnly) query.set('inStockOnly', 'true');
  if (params?.q) query.set('q', params.q);
  const qs = query.toString() ? `?${query.toString()}` : '';
  return fetchJson(`/api/v1/b2b/new-products${qs}`);
}

export function applyWholesalerPrice(productId: number, input: {
  offerId?: number;
  priceHt?: number;
  sourceKey?: string;
  vatRate?: number;
}): Promise<{ status: string; productId: number; priceHt: number }> {
  return fetchJson(`/api/v1/b2b/products/${productId}/apply-wholesaler-price`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function applyBulkWholesalerPrices(items: Array<{
  productId: number;
  offerId?: number;
  priceHt?: number;
  sourceKey?: string;
  vatRate?: number;
}>): Promise<{ ok: boolean; appliedCount: number; items: Array<{ productId: number; priceHt: number; status: string }> }> {
  return fetchJson('/api/v1/b2b/products/apply-bulk-wholesaler-price', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ items }),
  });
}

export interface B2BWholesalerOfferSearchResultDto {
  readonly id: number;
  readonly sourceKey: string;
  readonly sourceLabel: string;
  readonly externalRef: string;
  readonly referenceRaw: string | null;
  readonly gtinRaw: string | null;
  readonly nameRaw: string;
  readonly brandRaw: string | null;
  readonly priceHt: number | null;
  readonly priceTtc: number | null;
  readonly vatRate: number | null;
  readonly unitPriceRealHt: number | null;
  readonly isPromo?: boolean;
  readonly promoPercent?: number | null;
  readonly promoBuyQty?: number | null;
  readonly promoFreeQty?: number | null;
  readonly inStock: boolean | null;
  readonly fetchedAt: string;
  readonly isMatchedToThisProduct: boolean;
}

export interface B2BWholesalerOfferSearchResponse {
  readonly items: readonly B2BWholesalerOfferSearchResultDto[];
  readonly total: number;
  readonly sources: readonly {
    readonly key: string;
    readonly label: string;
    readonly kind: string;
  }[];
}

export function searchB2BWholesalerOffers(params: {
  q: string;
  productId?: number | undefined;
  sourceKey?: string | undefined;
  limit?: number | undefined;
}): Promise<B2BWholesalerOfferSearchResponse> {
  const query = new URLSearchParams();
  query.set('q', params.q);
  if (params.productId) query.set('productId', String(params.productId));
  if (params.sourceKey && params.sourceKey !== 'all') query.set('sourceKey', params.sourceKey);
  if (params.limit) query.set('limit', String(params.limit));
  return fetchJson(`/api/v1/b2b/wholesaler-offers/search?${query.toString()}`);
}

export function matchB2BProductOffer(productId: number, input: {
  offerId: number;
  adoptPrice?: boolean | undefined;
  adoptVat?: boolean | undefined;
}): Promise<{ ok: boolean; offerId: number; productId: number; priceAdopted: boolean }> {
  return fetchJson(`/api/v1/b2b/products/${productId}/match-offer`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function unlinkB2BProductOffer(productId: number, offerId: number): Promise<{ ok: boolean; productId: number; offerId: number }> {
  return fetchJson(`/api/v1/b2b/products/${productId}/match-offer/${offerId}`, {
    method: 'DELETE',
  });
}

export function createDraftFromWholesaler(offerId: number): Promise<{
  status: string;
  productId: number;
  sku: string;
  name: string;
}> {
  return fetchJson('/api/v1/b2b/new-products/create-draft', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ offerId }),
  });
}

export function triggerPortalCrawl(portalKey: string): Promise<{
  status: string;
  portalKey: string;
  jobId: string | null;
}> {
  return fetchJson(`/api/v1/b2b/portals/${portalKey}/crawl`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({}),
  });
}

// ---------------------------------------------------------------------------
// S20 â€” Catalogue revision (product_enrichment, internal workbench)
// ---------------------------------------------------------------------------

export interface EnrichmentProposal {
  readonly id: number;
  readonly status: 'proposed' | 'accepted' | 'rejected';
  readonly sourceKey: string;
  readonly sourceUrl: string;
  readonly product: {
    readonly id: number;
    readonly sku: string;
    readonly name: string;
    readonly brand: string | null;
    readonly image: string | null;
    readonly isPublished: boolean;
    readonly status: string;
    readonly sizeValue: number | null;
    readonly sizeUnit: string | null;
    readonly gtinCanonical: string | null;
    readonly barcodeRaw: string | null;
    readonly eanRaw: string | null;
  };
  readonly proposal: {
    readonly name: string | null;
    readonly brand: string | null;
    readonly image: string | null;
    readonly gallery: readonly string[];
    readonly category: string | null;
    readonly gtin: string | null;
    readonly contenanceRaw: string | null;
    readonly contenanceValue: number | null;
    readonly contenanceUnit: string | null;
    readonly contenancePack: number;
    readonly form: string | null;
    readonly presentation: string | null;
    readonly description: string | null;
    readonly shortDescription: string | null;
  };
  readonly diff: {
    readonly nameChanged: boolean;
    readonly brandChanged: boolean;
    readonly contChanged: boolean;
    readonly contMissing: boolean;
    readonly gtinChanged: boolean;
  };
  readonly decidedBy: string | null;
  readonly decidedAt: string | null;
  readonly note: string | null;
  readonly editedByHuman: boolean;
  readonly lastSeenAt: string;
}

export interface EnrichmentSourceOfferMatch {
  readonly id: number;
  readonly sourceKey: string;
  readonly sourceLabel: string;
  readonly name: string;
  readonly brand: string | null;
  readonly gtin: string | null;
  readonly image: string | null;
  readonly url: string | null;
  readonly priceTtc: number | null;
}

export interface EnrichmentList {
  readonly total: number;
  readonly limit: number;
  readonly skip: number;
  readonly counts: readonly { status: string; sourceKey: string; count: number }[];
  readonly items: readonly EnrichmentProposal[];
  readonly sourceOfferMatches?: readonly EnrichmentSourceOfferMatch[];
}

export interface EnrichmentQuery {
  status?: string;
  sourceKey?: string;
  onlyChangedName?: boolean;
  onlyMissingContenance?: boolean;
  search?: string;
  limit?: number;
  skip?: number;
}

export function fetchEnrichmentProposals(query: EnrichmentQuery = {}): Promise<EnrichmentList> {
  const params = new URLSearchParams();
  if (query.status !== undefined) params.set('status', query.status);
  if (query.sourceKey !== undefined) params.set('sourceKey', query.sourceKey);
  if (query.onlyChangedName === true) params.set('onlyChangedName', '1');
  if (query.onlyMissingContenance === true) params.set('onlyMissingContenance', '1');
  if (query.search !== undefined && query.search !== '') params.set('search', query.search);
  params.set('limit', String(query.limit ?? 50));
  params.set('skip', String(query.skip ?? 0));
  return fetchJson(`/api/v1/enrichment/proposals?${params.toString()}`);
}

export interface EnrichmentDecisionInput {
  decision: 'accept' | 'reject';
  note?: string;
  name?: string;
  brand?: string;
  gtin?: string;
  contenanceValue?: number;
  contenanceUnit?: string;
  contenancePack?: number;
  form?: string;
  presentation?: string;
}

export function decideEnrichment(
  id: number,
  input: EnrichmentDecisionInput,
): Promise<{ id?: number; status: string; currentStatus?: string; decidedBy?: string }> {
  return fetchJson(`/api/v1/enrichment/proposals/${id}/decide`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function deleteEnrichmentProposal(id: number): Promise<{ ok: boolean; id: number }> {
  return fetchJson(`/api/v1/enrichment/proposals/${id}`, {
    method: 'DELETE',
  });
}

// ---------------------------------------------------------------------------
// S12 â€” Sauvegardes & restauration (Cloudflare R2)
// ---------------------------------------------------------------------------

export interface BackupRetentionDto {
  readonly hourly: number;
  readonly daily: number;
  readonly weekly: number;
  readonly monthly: number;
}

export interface BackupConfigDto {
  readonly source: 'vault' | 'env' | 'none';
  readonly configured: boolean;
  readonly accountId: string;
  readonly accessKeyId: string;
  readonly bucket: string;
  readonly prefix: string;
  readonly enabled: boolean;
  readonly retention: BackupRetentionDto;
  readonly updatedBy: string | null;
  readonly updatedAt: string | null;
  readonly masterKeyPresent: boolean;
}

export interface BackupItemDto {
  readonly key: string;
  readonly tier: 'hourly' | 'daily' | 'weekly' | 'monthly' | 'local';
  readonly bytes: number;
  readonly createdAt: string;
  readonly source: 'r2' | 'local';
}

export interface BackupHealthDto {
  readonly status: 'ok' | 'stale' | 'empty' | 'not_configured';
  readonly lastBackupAt: string | null;
  readonly lastBackupAgeHours: number | null;
  readonly count: number;
  readonly totalBytes: number;
}

export interface BackupsListDto {
  readonly source: 'vault' | 'env' | 'none';
  readonly configured: boolean;
  readonly enabled: boolean;
  readonly retention: BackupRetentionDto;
  readonly autoSchedule: string;
  readonly items: readonly BackupItemDto[];
  readonly r2Error: string | null;
  readonly health: BackupHealthDto;
}

export interface RestorePlanDto {
  readonly key: string;
  readonly command: string;
  readonly drillCommand: string;
  readonly checklist: readonly string[];
  readonly warnings: readonly string[];
}

export function fetchBackups(): Promise<BackupsListDto> {
  return fetchJson('/api/v1/backups');
}

export function fetchBackupConfig(): Promise<BackupConfigDto> {
  return fetchJson('/api/v1/backups/config');
}

export function saveBackupConfig(input: {
  accountId: string;
  accessKeyId: string;
  secretAccessKey?: string;
  bucket: string;
  prefix: string;
  enabled: boolean;
  retention: BackupRetentionDto;
}): Promise<{ status: string }> {
  return fetchJson('/api/v1/backups/config', {
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function runBackup(): Promise<{
  status: string;
  file: string;
  bytes: number;
  durationMs: number;
  uploaded: readonly string[];
  skipped: string | null;
  pruned: readonly string[];
}> {
  return fetchJson('/api/v1/backups/run', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({}),
  });
}

export function testBackupConnection(): Promise<{ ok: boolean; detail: string; source: string }> {
  return fetchJson('/api/v1/backups/test', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({}),
  });
}

export function verifyBackup(key: string): Promise<{
  ok: boolean;
  checked: string;
  entries: number;
  tables: number;
  error: string | null;
}> {
  return fetchJson(`/api/v1/backups/${encodeURIComponent(key)}/verify`);
}

export function deleteBackup(key: string): Promise<{ status: string; key: string }> {
  return fetchJson(`/api/v1/backups/${encodeURIComponent(key)}`, { method: 'DELETE' });
}

// ---------------------------------------------------------------------------
// S31 â€” Ruptures & disponibilitÃ©
// ---------------------------------------------------------------------------

export interface OutOfStockAvailabilityDto {
  readonly sourceKey: string;
  readonly sourceLabel: string;
  readonly sourceKind: 'depot' | 'competitor' | 'wholesaler' | 'other';
  readonly gtin: string | null;
  readonly priceTtc: number | null;
  readonly inStock: boolean | null;
  readonly stockQty: number | null;
  readonly url: string | null;
  /** When the source was last collected. */
  readonly fetchedAt: string | null;
  readonly priceHt?: number | null;
  readonly vatRate?: number | null;
  readonly isPromo?: boolean;
  readonly promoLabel?: string | null;
  readonly promoBuyQty?: number | null;
  readonly promoFreeQty?: number | null;
  readonly promoPercent?: number | null;
  readonly unitPriceRealHt?: number | null;
  readonly b2bProductName?: string | null;
}

export interface OutOfStockItemDto {
  readonly id: number;
  readonly sku: string;
  readonly name: string;
  readonly brand: string | null;
  readonly gtin: string | null;
  readonly stockQty: number | null;
  readonly inStock: boolean | null;
  readonly image: string | null;
  readonly regularPriceTtc: string | number | null;
  readonly salePriceTtc: string | number | null;
  readonly purchasePriceHt: string | number | null;
  readonly purchaseSourceKey: string | null;
  readonly isVariation: boolean;
  readonly parentSku: string | null;
  readonly depot: readonly OutOfStockAvailabilityDto[];
  readonly depotAvailable: readonly OutOfStockAvailabilityDto[];
  readonly competitors: readonly OutOfStockAvailabilityDto[];
  readonly competitorsInStock: readonly OutOfStockAvailabilityDto[];
  /** Competitors with a collection younger than 7 days. */
  readonly competitorsInStockFresh: readonly OutOfStockAvailabilityDto[];
  readonly wholesalers?: readonly OutOfStockAvailabilityDto[];
  readonly wholesalerAvailable: readonly OutOfStockAvailabilityDto[];
  readonly canRestock: boolean;
  readonly soldByCompetitors: number;
  readonly soldByCompetitorsFresh: number;
  readonly competitorOpportunity: boolean;
  readonly competitorOpportunityFresh: boolean;
}

export function fetchOutOfStock(params: {
  q?: string;
  brand?: string;
  excludedSubBrands?: string;
  restockable?: string;
  competitorStock?: string;
  limit?: number;
  skip?: number;
}): Promise<{
  readonly total: number;
  readonly counts: {
    readonly outOfStock: number;
    readonly restockable: number;
    readonly competitorOpportunity: number;
    /** Opportunities backed by a collection younger than 7 days. */
    readonly competitorOpportunityFresh: number;
    readonly neither: number;
  };
  readonly brands: readonly string[];
  readonly items: readonly OutOfStockItemDto[];
}> {
  const qs = new URLSearchParams();
  if (params.q !== undefined && params.q !== '') qs.set('q', params.q);
  if (params.brand !== undefined && params.brand !== 'all') qs.set('brand', params.brand);
  if (params.excludedSubBrands !== undefined && params.excludedSubBrands !== '') qs.set('excludedSubBrands', params.excludedSubBrands);
  if (params.restockable !== undefined) qs.set('restockable', params.restockable);
  if (params.competitorStock !== undefined) qs.set('competitorStock', params.competitorStock);
  qs.set('limit', String(params.limit ?? 100));
  qs.set('skip', String(params.skip ?? 0));
  return fetchJson(`/api/v1/catalogue/out-of-stock?${qs.toString()}`);
}

// ---------------------------------------------------------------------------
// S30 â€” Inventaire rapide (quick stock count per brand)
// ---------------------------------------------------------------------------

export interface InventoryBrandDto {
  readonly brand: string;
  readonly count: number;
}

export interface InventoryOpenSessionDto {
  readonly id: number;
  readonly brand: string;
  readonly startedBy: string;
  readonly startedAt: string;
}

export interface InventoryProductDto {
  readonly id: number;
  readonly sku: string;
  readonly name: string;
  readonly brand: string | null;
  readonly gtinCanonical: string | null;
  readonly barcodeRaw: string | null;
  readonly eanRaw: string | null;
  readonly stockQty: number | null;
  readonly inStock: boolean | null;
  readonly isPublished: boolean;
  readonly isVisible: boolean;
  readonly images: readonly string[];
  readonly wcProductId: number;
  readonly wcParentId: number | null;
  readonly isVariation: boolean;
  readonly regularPriceTtc: string | number | null;
  /** True when a count line exists — even at zero ("verified absent"). */
  readonly counted: boolean;
  /** Counted quantity (accumulates across scans). */
  readonly countedQuantity: number;
  /** How many times the product was scanned. */
  readonly scans: number;
  readonly expectedQty: number | null;
}

export interface InventorySessionDto {
  readonly id: number;
  readonly brand: string;
  readonly status: string;
  readonly startedBy: string;
  readonly startedAt: string;
  readonly appliedAt: string | null;
  readonly appliedBy: string | null;
  readonly note: string | null;
}

export function fetchInventoryBrands(): Promise<{
  readonly brands: readonly InventoryBrandDto[];
  readonly openSessions: readonly InventoryOpenSessionDto[];
}> {
  return fetchJson('/api/v1/inventory/brands');
}

export function createInventorySession(brand: string): Promise<{
  readonly status: string;
  readonly session: InventorySessionDto;
}> {
  return fetchJson('/api/v1/inventory/sessions', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ brand }),
  });
}

export function fetchInventorySession(sessionId: number): Promise<{
  readonly session: InventorySessionDto;
  readonly products: readonly InventoryProductDto[];
  readonly countedCount: number;
}> {
  return fetchJson(`/api/v1/inventory/sessions/${sessionId}`);
}

/**
 * Scan or update a count line.
 * - `code` alone identifies the product (no count change).
 * - `{ productId, quantity }` with mode `add` (default) adds a delta to the
 *   count — scan = +1, undo = −1.
 * - mode `set` writes the ABSOLUTE counted value (manual entry).
 */
export function scanInventoryProduct(
  sessionId: number,
  code: string,
  productId?: number,
  quantity?: number,
  mode?: 'add' | 'set',
): Promise<{
  readonly status: string;
  readonly kind: string;
  readonly line: {
    readonly productId: number;
    readonly quantity: number;
    readonly scans: number;
    readonly expectedQty: number | null;
  };
  readonly product: InventoryProductDto;
}> {
  return fetchJson(`/api/v1/inventory/sessions/${sessionId}/scan`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      ...(code !== '' ? { code } : {}),
      ...(productId !== undefined ? { productId } : {}),
      ...(quantity !== undefined ? { quantity, ...(mode !== undefined ? { mode } : {}) } : {}),
    }),
  });
}

export function deleteInventoryLine(
  sessionId: number,
  productId: number,
): Promise<{ readonly status: string }> {
  return fetchJson(`/api/v1/inventory/sessions/${sessionId}/lines/${productId}`, {
    method: 'DELETE',
  });
}

export function applyInventorySession(sessionId: number): Promise<{
  readonly status: string;
  readonly batchId: number;
  readonly sent: number;
  readonly verified: number;
  readonly failed: number;
  readonly errors: readonly string[];
}> {
  return fetchJson(`/api/v1/inventory/sessions/${sessionId}/apply`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({}),
  });
}

export function cancelInventorySession(sessionId: number): Promise<{ readonly status: string }> {
  return fetchJson(`/api/v1/inventory/sessions/${sessionId}`, { method: 'DELETE' });
}

// ---------------------------------------------------------------------------
// S29 â€” Hidden products (masquÃ©s sur le site / Ã  masquer)
// ---------------------------------------------------------------------------

export interface HiddenProductRow {
  readonly id: number;
  readonly wcProductId: number;
  readonly wcParentId: number | null;
  readonly sku: string;
  readonly name: string;
  readonly brand: string | null;
  readonly image: string | null;
  readonly gtin: string | null;
  readonly stockQty: number | null;
  readonly inStock: boolean | null;
  readonly visibility: string;
  readonly operatorStatus: string;
  readonly lastSeenAt: string;
  /** LIVE WooCommerce state (the mirror can be stale). */
  readonly liveCatalogVisibility: string | null;
  readonly liveStatus: string | null;
  readonly liveStockQty: number | null;
  readonly liveStockStatus: string | null;
  readonly liveKnown: boolean;
  readonly hiddenBy?: string | null;
  readonly hiddenAt?: string | null;
  readonly stockParkedBy?: string | null;
  readonly stockParkedAt?: string | null;
}

export interface HiddenProductsResponse {
  readonly tab: 'hidden' | 'to-hide' | 'stale' | 'stock-wrong';
  /** False when WooCommerce could not be reached (list based on our mirror). */
  readonly liveChecked: boolean;
  readonly counts: {
    readonly hidden: number;
    readonly toHide: number;
    /** Our mirror said hidden, the site says otherwise â€” reconciled. */
    readonly stale: number;
    /** The shop could not be read for these rows â€” nothing is claimed. */
    readonly unverified: number;
    readonly missingStock: number;
  };
  readonly brands: readonly { readonly brand: string; readonly count: number }[];
  readonly items: readonly HiddenProductRow[];
}

export function fetchHiddenProducts(params: {
  tab: 'hidden' | 'to-hide' | 'stale' | 'stock-wrong';
  q?: string;
  brand?: string;
  excludedSubBrands?: string;
}): Promise<HiddenProductsResponse> {
  const qs = new URLSearchParams({ tab: params.tab });
  if (params.q !== undefined && params.q !== '') qs.set('q', params.q);
  if (params.brand !== undefined && params.brand !== 'all') qs.set('brand', params.brand);
  if (params.excludedSubBrands !== undefined && params.excludedSubBrands !== '') qs.set('excludedSubBrands', params.excludedSubBrands);
  return fetchJson(`/api/v1/products/hidden?${qs.toString()}`);
}

export function hideProducts(productIds: readonly number[]): Promise<{
  ok: boolean;
  hiddenCount: number;
  batchId: number | null;
  verified: number;
  failed: number;
  errors: readonly string[];
}> {
  return fetchJson('/api/v1/products/hide-bulk', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ productIds: [...productIds] }),
  });
}

export function unhideProducts(productIds: readonly number[]): Promise<{
  ok: boolean;
  unhiddenCount: number;
  batchId: number | null;
  verified: number;
  failed: number;
  errors: readonly string[];
}> {
  return fetchJson('/api/v1/products/unhide-bulk', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ productIds: [...productIds] }),
  });
}

export function parkHiddenStock(productIds: readonly number[]): Promise<{
  ok: boolean;
  batchId: number;
  quantity: number;
  verified: number;
  failed: number;
  errors: readonly string[];
}> {
  return fetchJson('/api/v1/products/hidden/stock', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ productIds: [...productIds] }),
  });
}

export interface EnrichmentSiblingProposal {
  readonly id: number;
  readonly status: string;
  readonly sourceKey: string;
  readonly sourceUrl: string;
  readonly name: string | null;
  readonly brand: string | null;
  readonly gtin: string | null;
  readonly image: string | null;
  readonly gallery: readonly string[];
  readonly category: string | null;
  readonly description: string | null;
  readonly shortDescription: string | null;
}

export interface EnrichmentProductProposals {
  readonly product: {
    readonly id: number;
    readonly sku: string;
    readonly name: string;
    readonly brand: string | null;
    readonly image: string | null;
  };
  readonly proposals: readonly EnrichmentSiblingProposal[];
}

export function fetchEnrichmentProductProposals(productId: number): Promise<EnrichmentProductProposals> {
  return fetchJson(`/api/v1/enrichment/products/${productId}/proposals`);
}

export function triggerEnrichmentCrawl(
  sourceKey: string,
  options: { limit?: number; dryRun?: boolean; full?: boolean; resetCursor?: boolean } = {},
): Promise<{ status: string; sourceKey: string; jobId: string | null }> {
  return fetchJson(`/api/v1/enrichment/${sourceKey}/crawl`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(options),
  });
}

export interface LiveLookupProposal {
  id: number;
  productId: number;
  sourceKey: string;
  sourceUrl: string;
  proposedName: string | null;
  proposedBrand: string | null;
  proposedGtin: string | null;
  contenanceRaw: string | null;
  imageUrl: string | null;
  description?: string | null;
  shortDescription?: string | null;
  images?: readonly string[];
  outcome: 'created' | 'updated' | 'unchanged';
}

export interface LiveLookupUnlinkedRecord {
  sourceKey: string;
  sourceUrl: string;
  proposedName: string | null;
  proposedBrand: string | null;
  proposedGtin: string | null;
  contenance?: {
    raw: string;
    value: number | null;
    unit: string | null;
    packCount: number;
  } | null;
  form?: string | null;
  presentation?: string | null;
  imageUrl?: string | null;
  images?: readonly string[];
  category?: string | null;
  description?: string | null;
  shortDescription?: string | null;
}

export interface LiveLookupResult {
  ok: boolean;
  query: string;
  matchedProductId: number | null;
  matchedProductName: string | null;
  savedProposals: LiveLookupProposal[];
  unlinkedRecords: LiveLookupUnlinkedRecord[];
  totalFound: number;
  message: string;
}

export function liveLookupEnrichment(
  query: string,
  sourceKey?: string,
  productId?: number,
): Promise<LiveLookupResult> {
  return fetchJson('/api/v1/enrichment/live-lookup', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ query, sourceKey, productId }),
  });
}

export { toTitleCase };
export const smartTitleCase = toTitleCase;

/** Converts a string to Sentence case (capitalizes the first letter, lowercases the rest). */
export function toSentenceCase(text: string): string {
  if (!text) return '';
  const trimmed = text.trim();
  if (!trimmed) return '';
  const lower = trimmed.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export interface CreateWooDraftImageItem {
  readonly src: string;
  readonly isMain?: boolean;
}

export interface CreateWooDraftInput {
  proposalId?: number | undefined;
  productId?: number | undefined;
  offerId?: number | undefined;
  name: string;
  ean?: string | null | undefined;
  brand?: string | null | undefined;
  /** Nom de catÃ©gorie Woo â€” attachÃ©e au brouillon si elle existe sur le site. */
  category?: string | null | undefined;
  shortDescription?: string | null | undefined;
  description?: string | null | undefined;
  imageUrl?: string | null | undefined;
  images?: readonly CreateWooDraftImageItem[] | undefined;
  /** Laisser vide : Woo gÃ©nÃ¨re le SKU Ã  la crÃ©ation. */
  sku?: string | null | undefined;
  regularPrice?: string | number | null | undefined;
  contenance?: string | null | undefined;
}

export interface CreateWooDraftResult {
  ok: boolean;
  wcProductId: number;
  name: string;
  ean: string | null;
  status: string;
  editUrl: string;
  permalink: string | null;
}

export function createWooDraftFromEnrichment(
  input: CreateWooDraftInput,
): Promise<CreateWooDraftResult> {
  return fetchJson('/api/v1/enrichment/create-woo-draft', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}

// ---------------------------------------------------------------------------
// S22 â€” Crawled products discovery (competitor websites: pharma-shop, etc.)
// ---------------------------------------------------------------------------

export interface CrawledProductItem {
  readonly id: number;
  readonly sourceKey: string;
  readonly sourceLabel: string;
  readonly sourceTrust: number;
  readonly externalRef: string;
  readonly gtinRaw: string | null;
  readonly cleanGtin: string | null;
  readonly referenceRaw: string | null;
  readonly name: string;
  readonly brand: string | null;
  readonly priceTtc: number | null;
  readonly priceHt: number | null;
  readonly vatRate: number | null;
  readonly inStock: boolean | null;
  readonly url: string | null;
  readonly image: string | null;
  readonly fetchedAt: string;
  readonly isRecent: boolean;
  readonly existsInCatalog: boolean;
  readonly isLinked: boolean;
  readonly matchedProduct: {
    readonly id: number;
    readonly sku: string;
    readonly name: string;
    readonly brand: string | null;
    readonly regularPriceTtc: number | null;
    readonly gtinCanonical: string | null;
    readonly priceDiffTtc: number | null;
    readonly priceDiffPercent: number | null;
  } | null;
}

export interface CrawledProductsResponse {
  readonly items: readonly CrawledProductItem[];
  readonly pagination: {
    readonly total: number;
    readonly page: number;
    readonly limit: number;
    readonly totalPages: number;
  };
  readonly stats: {
    readonly totalAnalyzed: number;
    readonly totalMissing: number;
    readonly totalExisting: number;
    readonly totalRecent: number;
    readonly totalWithEan: number;
    readonly countsBySource: Record<string, { total: number; missing: number; existing: number; recent: number }>;
  };
}

export function fetchCrawledProducts(params?: {
  page?: number | undefined;
  limit?: number | undefined;
  sourceKey?: string | undefined;
  status?: 'all' | 'missing' | 'existing' | 'recent' | undefined;
  hasEan?: boolean | undefined;
  inStockOnly?: boolean | undefined;
  brand?: string | undefined;
  q?: string | undefined;
}): Promise<CrawledProductsResponse> {
  const query = new URLSearchParams();
  if (params?.page) query.set('page', String(params.page));
  if (params?.limit) query.set('limit', String(params.limit));
  if (params?.sourceKey && params.sourceKey !== 'all') query.set('sourceKey', params.sourceKey);
  if (params?.status && params.status !== 'all') query.set('status', params.status);
  if (params?.hasEan) query.set('hasEan', 'true');
  if (params?.inStockOnly) query.set('inStockOnly', 'true');
  if (params?.brand) query.set('brand', params.brand);
  if (params?.q) query.set('q', params.q);
  const qs = query.toString() ? `?${query.toString()}` : '';
  return fetchJson(`/api/v1/crawled-products${qs}`);
}

export function createDraftFromCrawledOffer(input: {
  offerId: number;
  customSku?: string | undefined;
  customName?: string | undefined;
  customBrand?: string | undefined;
  regularPriceTtc?: number | undefined;
}): Promise<{
  status: string;
  productId: number;
  sku: string;
  name: string;
  gtin: string | null;
  regularPriceTtc: number | null;
}> {
  return fetchJson('/api/v1/crawled-products/create-draft', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function linkCrawledOfferToProduct(input: {
  offerId: number;
  productId: number;
  asCanonicalGtin?: boolean;
}): Promise<{
  status: string;
  productId: number;
  offerId: number;
}> {
  return fetchJson('/api/v1/crawled-products/link-product', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}

// ---------------------------------------------------------------------------
// S23 â€” Final EAN Match (Pharmashop & Parashop + Topface Price List)
// ---------------------------------------------------------------------------

export interface CompetitorMatchItem {
  readonly source: 'pharma-shop' | 'parashop';
  readonly sourceLabel: 'Pharmashop' | 'Parashop';
  readonly offerId: number;
  readonly name: string;
  readonly gtin: string | null;
  readonly image: string | null;
  readonly url: string | null;
  readonly priceTtc: number | null;
  readonly inStock: boolean | null;
  readonly matchType: 'gtin' | 'name';
  readonly score: number;
  readonly gtinMatchesOurs: boolean;
}

export interface TopfacePriceListMatch {
  readonly offerId: number;
  readonly name: string;
  readonly barcode: string;
  readonly reference: string | null;
  readonly priceHt: number | null;
  readonly score: number;
  readonly isApproved: boolean;
  readonly matchType?: 'gtin' | 'name';
}

export interface FinalEanMatchRow {
  readonly id: number;
  readonly sku: string | null;
  readonly name: string;
  readonly brand: string | null;
  readonly images: readonly string[];
  readonly gtin: string | null;
  readonly barcodeRaw: string | null;
  readonly eanRaw: string | null;
  readonly isApproved: boolean;
  readonly finalEanConfirmed?: boolean;
  readonly finalEanConfirmedAt?: string | null;
  readonly finalEanConfirmedBy?: string | null;
  readonly layer1Approved?: boolean;
  readonly reviewStatus?: 'approved' | 'rejected' | 'proposed' | 'pending';
  readonly approvedAt: string | null;
  readonly approvedBy: string | null;
  readonly regularPriceTtc: number | null;
  readonly purchasePriceHt: number | null;
  readonly isTopface: boolean;
  readonly isVariation?: boolean;
  readonly wcParentId?: number | null;
  readonly wcType?: string;
  readonly needsWooCorrection?: boolean;
  readonly pharmashop: CompetitorMatchItem | null;
  readonly parashop: CompetitorMatchItem | null;
  readonly topfaceMatch: TopfacePriceListMatch | null;
  readonly wholesalerBuyBox?: {
    readonly offerId: number;
    readonly sourceKey: string;
    readonly sourceLabel: string;
    readonly priceHt: number;
    readonly inStock: boolean | null;
  } | null;
  readonly wholesalerOffersCount?: number;
  readonly hasDivergence?: boolean;
  readonly divergenceReason?: string | null;
}

export interface FinalEanClaimMeta {
  readonly myCount: number;
  readonly totalPending: number;
  readonly reviewers: readonly { readonly userId: number; readonly name: string; readonly count: number }[];
}

export interface FinalEanMatchResponse {
  readonly items: readonly FinalEanMatchRow[];
  readonly total: number;
  readonly page: number;
  readonly limit: number;
  readonly totalPages: number;
  /** reservation state â€” non-null in the default 'mine' scope */
  readonly claim?: FinalEanClaimMeta | null;
}

export interface FinalEanMatchKpis {
  readonly totalApproved: number;
  readonly layer2ConfirmedCount?: number;
  readonly layer2PendingCount?: number;
  readonly readyForS19Count?: number;
  readonly matchedPharmashop: number;
  readonly matchedParashop: number;
  readonly matchedBoth: number;
  readonly divergentCount?: number;
  readonly topfaceTotal: number;
  readonly topfaceApproved: number;
  readonly topfaceMissingEan: number;
  readonly pendingApproval?: number;
  readonly correctionsCount?: number;
}

export interface FinalEanMatchBrand {
  readonly brand: string;
  readonly count: number;
}

export function fetchFinalEanMatch(params?: {
  page?: number | undefined;
  limit?: number | undefined;
  q?: string | undefined;
  brand?: string | undefined;
  excludedSubBrands?: string | undefined;
  matchFilter?: string | undefined;
  statusFilter?: string | undefined;
  scope?: 'mine' | 'all' | undefined;
}): Promise<FinalEanMatchResponse> {
  const query = new URLSearchParams();
  if (params?.page !== undefined) query.set('page', String(params.page));
  if (params?.limit !== undefined) query.set('limit', String(params.limit));
  if (params?.q) query.set('q', params.q);
  if (params?.brand && params.brand !== 'all') query.set('brand', params.brand);
  if (params?.excludedSubBrands) query.set('excludedSubBrands', params.excludedSubBrands);
  if (params?.matchFilter && params.matchFilter !== 'all') query.set('matchFilter', params.matchFilter);
  if (params?.statusFilter) query.set('statusFilter', params.statusFilter);
  if (params?.scope) query.set('scope', params.scope);
  const qs = query.toString() ? `?${query.toString()}` : '';
  return fetchJson(`/api/v1/final-ean-match${qs}`);
}

/** Release my reserved Final EAN Match batch (like the Workbench Â« LibÃ©rer mon lot Â»). */
export function releaseFinalEanMatchClaims(): Promise<{ ok: boolean; released: number }> {
  return fetchJson('/api/v1/final-ean-match/release-claims', { method: 'POST' });
}

export function fetchFinalEanMatchKpis(): Promise<FinalEanMatchKpis> {
  return fetchJson('/api/v1/final-ean-match/kpis');
}

export interface WooWebhookInfo {
  readonly id: number;
  readonly name: string | null;
  readonly topic: string;
  readonly status: string;
  readonly deliveryUrl: string;
}

export function fetchWooWebhooks(): Promise<{
  ok: boolean;
  error?: string;
  secretConfigured?: boolean;
  deliveryUrl?: string;
  webhooks?: readonly WooWebhookInfo[];
}> {
  return fetchJson('/api/v1/woo-engine/webhooks');
}

export function installWooWebhooks(): Promise<{
  ok: boolean;
  created: readonly string[];
  updated: readonly string[];
  deliveryUrl: string;
  secretPreview: string;
}> {
  return fetchJson('/api/v1/woo-engine/install-webhooks', { method: 'POST' });
}

/** Manual full-mirror trigger (products + variations + flags + soft-offline). */
export function runWooMirrorNow(): Promise<{ ok: boolean; queued: boolean; jobId: string | null }> {
  return fetchJson('/api/v1/woo-engine/run-mirror', { method: 'POST' });
}

export interface WooOrdersSyncProgress {
  readonly running: boolean;
  readonly page: number;
  readonly fetched: number;
  readonly upserted: number;
  readonly forceFull: boolean;
  readonly totalEstimate?: number;
  readonly updatedAt: string;
  readonly completedAt?: string | null;
  readonly error?: string | null;
}

export interface WooMirrorProgress {
  readonly running: boolean;
  readonly page: number;
  readonly created: number;
  readonly updated: number;
  readonly skipped: number;
  readonly missingSku: number;
  readonly offlined?: number;
  readonly variations?: number;
  readonly updatedAt: string;
  readonly doneAt?: string | null;
  readonly error?: string | null;
}

export interface WooOrdersStatusView {
  readonly totalStored: number;
  readonly lastSyncedAt: string | null;
  readonly fullSyncDoneAt: string | null;
  readonly ordersSyncProgress?: WooOrdersSyncProgress | null;
  readonly mirrorProgress?: WooMirrorProgress | null;
}

export function fetchWooOrdersStatus(): Promise<WooOrdersStatusView> {
  return fetchJson('/api/v1/woo-engine/orders-status');
}

export function syncWooOrders(
  forceFull: boolean = false,
): Promise<{ ok: boolean; queued: boolean; jobId: string | null; forceFull: boolean }> {
  return fetchJson('/api/v1/woo-engine/sync-orders', {
    method: 'POST',
    body: JSON.stringify({ forceFull }),
  });
}

// ---------------------------------------------------------------------------
// Sales Stats (S21 â€” purchase manager)
// ---------------------------------------------------------------------------
export interface SalesStatsRow {
  readonly sku: string;
  readonly name: string;
  readonly brand: string | null;
  readonly image: string | null;
  readonly qtySold: number;
  readonly revenueTtc: number;
  readonly ordersCount: number;
  readonly lastSoldAt: string | null;
  /** smart purchase forecast: average monthly rate over the period */
  readonly monthlyRate: number;
  readonly forecast1: number;
  readonly forecast2: number;
  readonly forecast3: number;
  readonly stockQty: number | null;
  readonly coverageDays: number | null;
  readonly order1: number;
  readonly order2: number;
  readonly order3: number;
}

export interface SalesStatsResponse {
  readonly period: { readonly from: string; readonly to: string; readonly spanDays: number };
  /** the statuses whose orders count as sales in this aggregate */
  readonly countedStatuses?: readonly string[];
  readonly brand: string | null;
  readonly brandFamily: readonly string[] | null;
  readonly category: string | null;
  readonly totals: {
    readonly units: number;
    readonly revenue: number;
    readonly orders: number;
    readonly products: number;
  };
  readonly rows: readonly SalesStatsRow[];
}

/** Distinct order statuses present in the mirror + the current counted set. */
export function fetchSalesStatuses(): Promise<{
  readonly statuses: readonly { readonly status: string; readonly orders: number }[];
  readonly counted: readonly string[];
  readonly countedDefault: readonly string[];
}> {
  return fetchJson('/api/v1/sales-stats/statuses');
}

export function saveCountedStatuses(
  statuses: readonly string[],
): Promise<{ status: string; statuses: readonly string[] }> {
  return fetchJson('/api/v1/sales-stats/counted-statuses', {
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ statuses }),
  });
}

export function fetchSalesStats(params: {
  brand?: string | undefined;
  category?: string | undefined;
  days?: number | undefined;
  sort?: 'qty' | 'revenue' | undefined;
  from?: string | undefined;
  to?: string | undefined;
}): Promise<SalesStatsResponse> {
  const q = new URLSearchParams();
  if (params.brand && params.brand !== 'all') q.set('brand', params.brand);
  if (params.category && params.category !== 'all') q.set('category', params.category);
  if (params.from) q.set('from', params.from);
  if (params.to) q.set('to', params.to);
  if (params.days !== undefined && !params.from) q.set('days', String(params.days));
  if (params.sort !== undefined) q.set('sort', params.sort);
  const qs = q.toString() ? `?${q.toString()}` : '';
  return fetchJson(`/api/v1/sales-stats${qs}`);
}

export function fetchSalesStatsBrands(): Promise<{
  readonly brands: readonly { readonly brand: string; readonly brandNorm: string | null }[];
}> {
  return fetchJson('/api/v1/sales-stats/brands');
}

export function fetchSalesStatsCategories(): Promise<{
  readonly categories: readonly { readonly name: string; readonly count: number }[];
}> {
  return fetchJson('/api/v1/sales-stats/categories');
}

export interface BrandSalesTopProduct {
  readonly sku: string;
  readonly name: string;
  readonly image: string | null;
  readonly qtySold: number;
  readonly revenueTtc: number;
}

export interface BrandSalesRow {
  readonly brand: string;
  readonly brandNorm: string;
  readonly qtySold: number;
  readonly revenueTtc: number;
  readonly ordersCount: number;
  readonly distinctProductsSold: number;
  readonly catalogProductsCount: number;
  readonly stockQtyTotal: number | null;
  readonly revenueShare: number;
  readonly averageOrderValue: number;
  readonly topProducts: readonly BrandSalesTopProduct[];
  readonly lastSoldAt: string | null;
}

export interface BrandSalesResponse {
  readonly period: {
    readonly from: string;
    readonly to: string;
    readonly spanDays: number;
  };
  readonly countedStatuses: readonly string[];
  readonly totals: {
    readonly units: number;
    readonly revenue: number;
    readonly orders: number;
    readonly brandsCount: number;
  };
  readonly brands: readonly BrandSalesRow[];
}

export interface SalesSyncStatus {
  readonly lastOrder: {
    readonly wooId: number;
    readonly number: string;
    readonly status: string;
    readonly dateCreated: string | null;
  } | null;
  readonly ordersToday: {
    readonly total: number;
    readonly byStatus: readonly { readonly status: string; readonly count: number }[];
  };
  readonly lastSyncAt: string | null;
  readonly isSyncRunning: boolean;
  readonly syncError: string | null;
  readonly totalOrdersInDb: number;
  readonly isSyncHealthy: boolean;
}

export function fetchSalesByBrand(params: {
  days?: number | undefined;
  from?: string | undefined;
  to?: string | undefined;
  sort?: ('qty' | 'revenue' | 'orders' | 'products') | undefined;
  limit?: number | undefined;
  search?: string | undefined;
  includeProcessing?: boolean | undefined;
}): Promise<BrandSalesResponse> {
  const q = new URLSearchParams();
  if (params.from) q.set('from', params.from);
  if (params.to) q.set('to', params.to);
  if (params.days !== undefined && !params.from) q.set('days', String(params.days));
  if (params.sort !== undefined) q.set('sort', params.sort);
  if (params.limit !== undefined) q.set('limit', String(params.limit));
  if (params.search) q.set('search', params.search);
  if (params.includeProcessing !== undefined) q.set('includeProcessing', String(params.includeProcessing));
  const qs = q.toString() ? `?${q.toString()}` : '';
  return fetchJson(`/api/v1/sales-stats/by-brand${qs}`);
}

export function fetchSalesSyncStatus(): Promise<SalesSyncStatus> {
  return fetchJson('/api/v1/sales-stats/sync-status');
}

export function triggerOrdersSync(): Promise<{ ok: boolean; jobId?: string; message: string }> {
  return fetchJson('/api/v1/sales-stats/trigger-sync', {
    method: 'POST',
  });
}


export interface ReconcileSalesSummary {
  readonly totalProducts: number;
  readonly matchingCount: number;
  readonly discrepancyCount: number;
  readonly noCounterCount: number;
  readonly countedStatuses: readonly string[];
  readonly totalCalculatedUnits: number;
  readonly totalWooUnits: number;
}

export interface ReconcileSalesDiscrepancy {
  readonly wcProductId: number;
  readonly sku: string;
  readonly name: string;
  readonly brand: string | null;
  readonly image: string | null;
  readonly calculatedQty: number;
  readonly totalSalesWoo: number;
  readonly delta: number;
  readonly absDelta: number;
}

export interface ReconcileSalesResponse {
  readonly summary: ReconcileSalesSummary;
  readonly topDiscrepancies: readonly ReconcileSalesDiscrepancy[];
}

export function fetchReconcileTotalSales(limit = 50): Promise<ReconcileSalesResponse> {
  return fetchJson(`/api/v1/sales-stats/reconcile-total-sales?limit=${limit}`);
}

export function fetchFinalEanMatchBrands(): Promise<readonly FinalEanMatchBrand[]> {
  return fetchJson('/api/v1/final-ean-match/brands');
}

export function applyTopfaceEan(input: {
  productId: number;
  gtin: string;
  offerId?: number;
}): Promise<{
  ok: boolean;
  productId: number;
  gtin: string;
  decisionId: number;
  productName: string;
}> {
  return fetchJson('/api/v1/final-ean-match/apply-topface-ean', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function confirmFinalEanMatch(input: {
  productId: number;
  gtin?: string;
  allowSharedGtin?: boolean;
  generateInternal?: boolean;
}): Promise<{
  ok: boolean;
  productId: number;
  gtin: string;
  status: string;
  decidedBy: string;
  decidedAt: string;
}> {
  return fetchJson('/api/v1/final-ean-match/confirm', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function unconfirmFinalEanMatch(productId: number): Promise<{
  ok: boolean;
  productId: number;
  finalEanConfirmed: boolean;
}> {
  return fetchJson('/api/v1/final-ean-match/unconfirm', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ productId }),
  });
}

export function confirmBulkFinalEanMatch(input: {
  items?: Array<{ productId: number; gtin?: string }>;
  productIds?: number[];
}): Promise<{
  ok: boolean;
  confirmedCount: number;
  skippedCount: number;
  errors: readonly string[];
}> {
  return fetchJson('/api/v1/final-ean-match/confirm-bulk', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function rejectFinalEanMatch(input: {
  productId: number;
  note?: string;
}): Promise<{
  ok: boolean;
  productId: number;
  status: string;
  message: string;
}> {
  return fetchJson('/api/v1/final-ean-match/reject', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function fetchTopfaceSuggestions(params?: {
  productId?: number | undefined;
  q?: string | undefined;
}): Promise<{
  suggestions: readonly {
    id: number;
    name: string;
    barcode: string;
    reference: string | null;
    priceHt: number | null;
    score: number;
    isExactEan?: boolean;
    shadeConflict?: boolean;
  }[];
}> {
  const query = new URLSearchParams();
  if (params?.productId) query.set('productId', String(params.productId));
  if (params?.q) query.set('q', params.q);
  const qs = query.toString() ? `?${query.toString()}` : '';
  return fetchJson(`/api/v1/final-ean-match/topface-suggestions${qs}`);
}


export interface ProductLifecycleCandidate {
  readonly id: number;
  readonly sourceKey: string;
  readonly sourceLabel: string;
  readonly name: string;
  readonly priceTtc: number | null;
  readonly gtin: string | null;
  readonly score: number;
  readonly url: string | null;
}

export interface ProductLifecycleB2bOffer {
  readonly id: number;
  readonly sourceKey: string;
  readonly sourceLabel: string;
  readonly priceHt: number | null;
  readonly vatRate: number | null;
  readonly isSelected: boolean;
  readonly b2bProductName?: string | null;
  readonly isPromo?: boolean;
  readonly promoLabel?: string | null;
  readonly promoBuyQty?: number | null;
  readonly promoFreeQty?: number | null;
  readonly promoPercent?: number | null;
  readonly unitPriceRealHt?: number | null;
}

export interface ProductLifecycleItem {
  readonly id: number;
  readonly wcProductId: number;
  readonly sku: string;
  readonly name: string;
  readonly brand: string | null;
  readonly images: readonly string[];
  readonly wcType: string;
  readonly status: string;
  readonly inStock: boolean | null;
  readonly stockQty: number | null;
  readonly regularPriceTtc: number | null;
  readonly salePriceTtc: number | null;
  readonly isPublished: boolean;
  readonly isVisible: boolean;
  readonly operatorStatus: string;
  readonly barcodeRaw: string | null;
  readonly eanRaw: string | null;
  readonly gtinCanonical: string | null;

  readonly couche1: {
    readonly code: 'approved' | 'rejected' | 'pack' | 'hide' | 'conflict' | 'queue' | 'no_candidates';
    readonly label: string;
    readonly decidedBy: string | null;
    readonly decidedAt: string | null;
    readonly approvedGtin: string | null;
    readonly candidateCount: number;
    readonly candidates: readonly ProductLifecycleCandidate[];
  };

  readonly couche2: {
    readonly code: 'confirmed_layer2' | 'pending_layer2' | 'not_eligible';
    readonly label: string;
    readonly isConfirmed: boolean;
    readonly confirmedBy: string | null;
    readonly confirmedAt: string | null;
    readonly readyForS19: boolean;
  };

  readonly pricing: {
    readonly purchasePriceHt: number | null;
    readonly purchaseVatRate: number | null;
    readonly purchaseSourceKey: string | null;
    readonly offers: readonly ProductLifecycleB2bOffer[];
  };

  readonly links: {
    readonly wooEditUrl: string;
    readonly workbenchUrl: string;
    readonly finalEanUrl: string;
    readonly b2bUrl: string;
  };
}

export interface ProductLifecycleResponse {
  readonly total: number;
  readonly items: readonly ProductLifecycleItem[];
}

export function searchProductLifecycle(q: string): Promise<ProductLifecycleResponse> {
  const query = new URLSearchParams({ q });
  return fetchJson(`/api/v1/products/lifecycle-search?${query.toString()}`);
}

export function syncProductFromWoo(productId: number): Promise<{ ok: boolean; product: unknown }> {
  return fetchJson(`/api/v1/products/${productId}/sync-from-woo`, {
    method: 'POST',
  });
}

// ============================================================================
// Accounting â€” Delivered by YM (Year/Month Reconciliation)
// ============================================================================

export interface CarrierRateConfig {
  carrierKey: string;
  carrierLabel: string;
  deliveryPriceHt: number;
  returnPriceHt: number;
  vatRate: number;
}

export interface MatchedOrderItem {
  order: {
    id: number;
    wooId: number;
    number: string;
    status: string;
    customerName: string | null;
    billingPhone: string | null;
    phoneDigits: string | null;
    billingAddress: string | null;
    billingCity: string | null;
    billingGov: string | null;
    total: number | null;
    dateCreated: string | null;
    jetpackCode: string | null;
    trackingCode: string | null;
  };
  matchStatus: 'matched' | 'amount_mismatch' | 'returned' | 'in_transit' | 'unmatched';
  matchConfidence: 'exact' | 'high' | 'medium' | 'none';
  matchReason: string;
  carrierName: string | null;
  carrierKey: string | null;
  trackingNumber: string | null;
  carrierAmount: number | null;
  amountDifference: number;
  deliveryDate: string | null;
  sourceProof: string | null;
  syncWooEligible: boolean;
  syncTargetStatus: 'completed' | 'cancelled' | null;
  carrierRecordId?: number | null;
}

export interface UnmatchedCarrierRecordItem {
  id: number;
  carrierName: string;
  trackingNumber: string;
  orderRef: string | null;
  customerName: string | null;
  customerPhone: string | null;
  destination: string | null;
  amount: number;
  status: string;
  statusRaw: string;
  deliveryDate: string | null;
  filename: string | null;
  sheetName: string | null;
}

export interface CarrierBreakdownItem {
  carrierKey: string;
  carrierLabel: string;
  deliveredCount: number;
  returnedCount: number;
  collectedCod: number;
  deliveryPriceHt: number;
  returnPriceHt: number;
  feesDeliveryHt: number;
  feesReturnHt: number;
  totalFeesHt: number;
  totalFeesTtc: number;
  netPayout: number;
}

export interface DeliveredByYmKpis {
  totalOrders: number;
  totalWooAmount: number;
  totalDeliveredOrders: number;
  totalCollectedCod: number;
  coverageRate: number;
  unmatchedCount: number;
  unmatchedAmount: number;
  amountMismatchCount: number;
  amountMismatchDelta: number;
  returnedCount: number;
  returnedAmount: number;
  totalFeesDeliveryHt: number;
  totalFeesReturnHt: number;
  totalFeesTotalHt: number;
  totalFeesTotalTtc: number;
  netTotalExpected: number;
  syncWooEligibleCount: number;
}

export interface DeliveredByYmResponse {
  ym: string;
  kpis: DeliveredByYmKpis;
  carrierBreakdown: CarrierBreakdownItem[];
  orders: MatchedOrderItem[];
  unmatchedCarrierRecords: UnmatchedCarrierRecordItem[];
  pagination: {
    page: number;
    perPage: number;
    total: number;
    totalPages: number;
  };
}

export function fetchDeliveredByYm(params: {
  ym?: string | undefined;
  status?: string | undefined;
  carrier?: string | undefined;
  search?: string | undefined;
  page?: number | undefined;
  perPage?: number | undefined;
}): Promise<DeliveredByYmResponse> {
  const q = new URLSearchParams();
  if (params.ym) q.set('ym', params.ym);
  if (params.status) q.set('status', params.status);
  if (params.carrier) q.set('carrier', params.carrier);
  if (params.search) q.set('search', params.search);
  if (params.page) q.set('page', String(params.page));
  if (params.perPage) q.set('perPage', String(params.perPage));
  return fetchJson(`/api/v1/accounting/delivered-by-ym?${q.toString()}`);
}

export function syncCarrierFolder(): Promise<{
  ok?: boolean;
  success?: boolean;
  totalFiles?: number;
  filesScanned: number;
  newImports?: number;
  importsProcessed: number;
  totalRows: number;
  scannedFiles?: Array<{
    filename: string;
    carrierName?: string;
    totalRows: number;
    deliveredCount?: number;
    deliveredRows?: number;
    returnedCount?: number;
    returnedRows?: number;
  }>;
  results?: unknown[];
}> {
  return fetchJson('/api/v1/accounting/sync-carrier-folder', { method: 'POST' });
}

export async function uploadCarrierManifest(file: File): Promise<{
  ok?: boolean;
  success?: boolean;
  filename: string;
  carrierName: string;
  sheetCount: number;
  sheetsImported?: number;
  totalRows: number;
  deliveredRows: number;
  deliveredCount?: number;
  returnedRows: number;
  returnedCount?: number;
  totalAmount: number;
}> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch('/api/v1/accounting/carrier-manifest-upload', {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as { error?: string; detail?: string };
    throw new Error([body.error, body.detail].filter(Boolean).join(' â€” ') || `HTTP ${response.status}`);
  }
  return response.json();
}

export function fetchCarrierRates(): Promise<{ rates: CarrierRateConfig[] }> {
  return fetchJson('/api/v1/accounting/carrier-rates');
}

// Accounting â€” CA Carrier (per-carrier collected COD vs delivery fees)

export interface CarrierCaRow {
  carrierKey: string;
  carrierLabel: string;
  deliveredCount: number;
  deliveredCod: number;
  returnedCount: number;
  returnedCod: number;
  inTransitCount: number;
  inTransitCod: number;
  excelCod: number;
  shiparonCod: number;
  deliveryPriceHt: number;
  returnPriceHt: number;
  vatRate: number;
  feesDeliveryHt: number;
  feesReturnHt: number;
  totalFeesHt: number;
  totalFeesTtc: number;
  netPayout: number;
}

export interface CarrierCaTotals {
  carrierCount: number;
  deliveredCount: number;
  deliveredCod: number;
  returnedCount: number;
  returnedCod: number;
  inTransitCount: number;
  inTransitCod: number;
  excelCod: number;
  shiparonCod: number;
  totalFeesHt: number;
  totalFeesTtc: number;
  netPayout: number;
}

export interface CarrierCaRate {
  carrierKey: string;
  carrierLabel: string;
  deliveryPriceHt: number;
  returnPriceHt: number;
  vatRate: number;
}

export interface CarrierCaResponse {
  period: { from: string | null; to: string | null } | null;
  carriers: CarrierCaRow[];
  totals: CarrierCaTotals;
  rates: CarrierCaRate[];
}

export function fetchCarrierCa(params: { from?: string | undefined; to?: string | undefined }): Promise<CarrierCaResponse> {
  const q = new URLSearchParams();
  if (params.from) q.set('from', params.from);
  if (params.to) q.set('to', params.to);
  const suffix = q.toString();
  return fetchJson(`/api/v1/accounting/carrier-ca${suffix ? `?${suffix}` : ''}`);
}

// Catalogue â€” Prix Concurrents (our TTC vs competitor TTC, TTC only)

export type CompetitorBadge = 'leader' | 'aligned' | 'above';

export interface CompetitorSourcePrice {
  sourceKey: string;
  sourceLabel: string;
  price: number;
  url: string | null;
}

export interface CompetitorRow {
  productId: number;
  wcProductId?: number | null;
  sku: string;
  name: string;
  brand: string | null;
  gtinCanonical?: string | null;
  image?: string | null;
  regularPriceTtc?: number | null;
  salePriceTtc?: number | null;
  ourPrice: number | null;
  prices: CompetitorSourcePrice[];
  cheapest: number | null;
  cheapestSourceKey: string | null;
  gapPct: number | null;
  gapTnd: number | null;
  badge: CompetitorBadge | null;
}

export interface CompetitorTotals {
  products: number;
  leaderCount: number;
  alignedCount: number;
  aboveCount: number;
  avgGapPctAbove: number | null;
}

export interface CompetitorSourceMeta {
  key: string;
  label: string;
  lastCrawlAt: string | null;
}

export interface CompetitorPricesResponse {
  rows: CompetitorRow[];
  totals: CompetitorTotals;
  sources: CompetitorSourceMeta[];
  pagination: {
    page: number;
    perPage: number;
    total: number;
    totalPages: number;
  };
  allowedBrands?: string[] | null;
}

export function fetchCompetitorPrices(params: {
  search?: string | undefined;
  brand?: string | undefined;
  excludedSubBrands?: string | undefined;
  sources?: string | undefined;
  minGapPct?: number | undefined;
  sort?: 'gap_desc' | 'gap_asc' | undefined;
  page?: number | undefined;
  perPage?: number | undefined;
}): Promise<CompetitorPricesResponse> {
  const q = new URLSearchParams();
  if (params.search) q.set('search', params.search);
  if (params.brand) q.set('brand', params.brand);
  if (params.excludedSubBrands) q.set('excludedSubBrands', params.excludedSubBrands);
  if (params.sources) q.set('sources', params.sources);
  if (params.minGapPct !== undefined) q.set('minGapPct', String(params.minGapPct));
  if (params.sort) q.set('sort', params.sort);
  if (params.page) q.set('page', String(params.page));
  if (params.perPage) q.set('perPage', String(params.perPage));
  return fetchJson(`/api/v1/prices/competitors?${q.toString()}`);
}

export function updateCompetitorProductPrice(
  productId: number,
  payload: {
    regularPrice?: number | string | null;
    salePrice?: number | string | null;
    clearSale?: boolean;
  },
): Promise<{
  ok: boolean;
  product: {
    id: number;
    wcProductId: number | null;
    sku: string;
    name: string;
    regularPriceTtc: number | null;
    salePriceTtc: number | null;
    ourPrice: number | null;
  };
  message: string;
}> {
  return fetchJson(`/api/v1/prices/competitors/products/${productId}/update-price`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function updateCarrierRates(rates: CarrierRateConfig[]): Promise<{ success: boolean; rates: CarrierRateConfig[] }> {
  return fetchJson('/api/v1/accounting/carrier-rates', {
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ rates }),
  });
}

export function manualMatchCarrierRecord(carrierRecordId: number, wooOrderId: number): Promise<{ ok: boolean; matchedWooOrderId: number }> {
  return fetchJson('/api/v1/accounting/manual-match', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ carrierRecordId, wooOrderId }),
  });
}

export function manualUnmatchCarrierRecord(carrierRecordId: number): Promise<{ ok: boolean }> {
  return fetchJson('/api/v1/accounting/manual-unmatch', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ carrierRecordId }),
  });
}

export interface SyncWooStatusItem {
  wooId: number;
  orderNumber: string;
  targetStatus: 'completed' | 'cancelled';
  currentStatus?: string;
  success?: boolean;
  error?: string;
}

export interface SyncWooStatusResult {
  ok?: boolean;
  status?: string;
  dryRun: boolean;
  totalUpdates: number;
  countCompleted?: number;
  countCancelled?: number;
  successCount?: number;
  failedCount?: number;
  updates: SyncWooStatusItem[];
  errors?: Array<{ wooId: number; error: string }>;
}

export function syncWooDeliveredStatuses(payload: {
  ym?: string;
  dryRun?: boolean;
  orderUpdates?: Array<{ wooId: number; targetStatus: 'completed' | 'cancelled'; orderNumber: string }>;
}): Promise<SyncWooStatusResult> {
  return fetchJson('/api/v1/accounting/sync-woo-statuses', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export interface HideProductResult {
  ok: boolean;
  hiddenCount: number;
  alreadyHidden: number;
  batchId?: number | null;
  pendingWooPush?: number;
  verified?: number;
  failed?: number;
  errors?: string[];
}

export function hideProductOnWooCommerce(productId: number): Promise<HideProductResult> {
  return fetchJson('/api/v1/shipping/hide-bulk', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ productIds: [productId] }),
  });
}

export function hideProductsOnWooCommerce(productIds: number[]): Promise<HideProductResult> {
  return fetchJson('/api/v1/shipping/hide-bulk', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ productIds }),
  });
}

export function unhideProductOnWooCommerce(productId: number): Promise<HideProductResult> {
  return fetchJson('/api/v1/shipping/unhide-bulk', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ productIds: [productId] }),
  });
}

// ---- Crawls & Crons Monitoring API -----------------------------------------

export interface CrawlProgress {
  readonly percent: number | null;
  readonly current: number;
  readonly total: number;
  readonly stage: string;
}

export interface RunningCrawlItem {
  readonly id: string;
  readonly jobId: string;
  readonly name: string;
  readonly label: string;
  readonly category: string;
  readonly queue: string;
  readonly startedAt: string;
  readonly durationMs: number;
  readonly status?: 'running' | 'waiting';
  readonly isWaiting?: boolean;
  readonly queuePosition?: number | null;
  readonly progress: CrawlProgress;
  readonly metrics: {
    readonly urlsFetched?: number;
    readonly offersCreated?: number;
    readonly offersUpdated?: number;
    readonly errors?: number;
    readonly stage?: string;
  };
}

export interface CronSchedulerItem {
  readonly id: string;
  readonly jobName: string;
  readonly queue: string;
  readonly category: string;
  readonly label: string;
  readonly description: string;
  readonly pattern: string;
  readonly humanSchedule: string;
  readonly nextRunAt: string | null;
  readonly nextRunInMs: number | null;
  readonly cycleIntervalMs: number;
  readonly isRunning: boolean;
  readonly isQueued?: boolean;
  readonly queuePosition?: number | null;
  readonly activeProgress: CrawlProgress | null;
  readonly timeUntilNextPercent: number;
  readonly lastRun: {
    readonly status: 'Successed' | 'Failed' | null;
    readonly startedAt: string | null;
    readonly finishedAt: string | null;
    readonly durationMs: number | null;
    readonly error: string | null;
  } | null;
}

export interface ExecutionRecord {
  readonly id: string;
  readonly sourceType: 'crawl' | 'cron' | 'sync' | 'portal';
  readonly name: string;
  readonly label: string;
  readonly category: string;
  readonly queue: string;
  readonly status: 'Successed' | 'Failed' | 'En cours';
  readonly startedAt: string;
  readonly finishedAt: string | null;
  readonly durationMs: number;
  readonly durationFormatted: string;
  readonly metrics: {
    readonly urlsFetched?: number;
    readonly offersCreated?: number;
    readonly offersUpdated?: number;
    readonly errors?: number;
    readonly rowCount?: number;
    readonly stage?: string;
    readonly details?: string;
  };
  readonly error: string | null;
}

export interface CrawlsMonitoringResponse {
  readonly runningCrawls: readonly RunningCrawlItem[];
  readonly cronSchedulers: readonly CronSchedulerItem[];
  readonly lastExecutions: readonly ExecutionRecord[];
  readonly serverTime: string;
}

export function fetchCrawlsMonitoring(): Promise<CrawlsMonitoringResponse> {
  return fetchJson('/api/v1/crawls-monitoring');
}

export function triggerCronJob(
  jobName: string,
  queueName?: string,
  data?: Record<string, unknown>,
): Promise<{ ok: boolean; queued: boolean; jobId: string | null }> {
  return fetchJson('/api/v1/crawls-monitoring/trigger', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ jobName, queueName, data }),
  });
}

export function cancelCrawlJob(
  jobId: string,
  queueName?: string,
): Promise<{ ok: boolean; cancelled: boolean }> {
  return fetchJson('/api/v1/crawls-monitoring/cancel', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ jobId, queueName }),
  });
}

// ---------------------------------------------------------------------------
// Price Adjustment API (S28)
// ---------------------------------------------------------------------------

export interface PriceAdjustmentBrandsResponse {
  readonly ok: boolean;
  readonly brands: readonly BrandPriceStats[];
  readonly overall: {
    readonly totalProducts: number;
    readonly withPurchasePrice: number;
    readonly missingPurchasePrice: number;
  };
}

export interface PriceAdjustmentProductsResponse {
  readonly ok: boolean;
  readonly items: readonly PriceAdjustmentProductItem[];
  readonly summary: {
    readonly totalProducts: number;
    readonly withPurchasePrice: number;
    readonly missingPurchasePrice: number;
    readonly needUpdateCount: number;
    readonly increaseCount: number;
    readonly decreaseCount: number;
    readonly equalCount: number;
    readonly avgDiffTnd: number;
    readonly marginPctApplied: number;
    readonly roundingApplied: PriceRoundingStrategy;
  };
  readonly pagination: {
    readonly page: number;
    readonly limit: number;
    readonly totalItems: number;
    readonly totalPages: number;
  };
}

export interface ParsedSupplierRowItem {
  readonly rowId: string;
  readonly sheetName: string;
  readonly rawDesignation: string;
  readonly rawBrand: string;
  readonly priceHt: number;
  readonly vatRate: number;
  readonly wholesalerSuggestedTtc: number | null;
  readonly matchedProduct: {
    readonly id: number;
    readonly wcProductId: number;
    readonly sku: string;
    readonly name: string;
    readonly brand: string | null;
    readonly gtinCanonical: string | null;
    readonly currentRegularPriceTtc: number | null;
    readonly currentPurchasePriceHt: number | null;
    readonly image: string | null;
  } | null;
  readonly candidates: readonly {
    readonly id: number;
    readonly sku: string;
    readonly name: string;
    readonly brand: string | null;
    readonly score: number;
    readonly currentRegularPriceTtc: number | null;
  }[];
  readonly confidence: 'high' | 'medium' | 'low' | 'none';
  readonly score: number;
}

export interface ParseSupplierFileResponse {
  readonly ok: boolean;
  readonly totalRows: number;
  readonly highConfidenceCount: number;
  readonly mediumConfidenceCount: number;
  readonly unmatchedCount: number;
  readonly rows: readonly ParsedSupplierRowItem[];
}

export function fetchPriceAdjustmentBrands(): Promise<PriceAdjustmentBrandsResponse> {
  return fetchJson('/api/v1/price-adjustment/brands');
}

export function fetchPriceAdjustmentProducts(params: {
  brand?: string;
  excludedSubBrands?: string;
  search?: string;
  marginPct?: number;
  vatRate?: number;
  rounding?: PriceRoundingStrategy;
  statusFilter?: PriceAdjustmentStatus | 'all' | 'need_update';
  page?: number;
  limit?: number;
}): Promise<PriceAdjustmentProductsResponse> {
  const sp = new URLSearchParams();
  if (params.brand) sp.set('brand', params.brand);
  if (params.excludedSubBrands) sp.set('excludedSubBrands', params.excludedSubBrands);
  if (params.search) sp.set('search', params.search);
  if (params.marginPct !== undefined) sp.set('marginPct', String(params.marginPct));
  if (params.vatRate !== undefined) sp.set('vatRate', String(params.vatRate));
  if (params.rounding) sp.set('rounding', params.rounding);
  if (params.statusFilter) sp.set('statusFilter', params.statusFilter);
  if (params.page) sp.set('page', String(params.page));
  if (params.limit) sp.set('limit', String(params.limit));
  return fetchJson(`/api/v1/price-adjustment/products?${sp.toString()}`);
}

export function updatePurchasePrice(body: {
  productId: number;
  purchasePriceHt: number;
  purchaseVatRate?: number;
  sourceKey?: string;
}): Promise<{ ok: boolean; product: { id: number; sku: string; name: string; purchasePriceHtMillimes: number | null } }> {
  return fetchJson('/api/v1/price-adjustment/update-purchase-price', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export function applyPriceAdjustments(body: {
  items: readonly { productId: number; newRegularPriceTtc: number }[];
  syncToWoo?: boolean;
}): Promise<{ ok: boolean; updatedCount: number; totalCount: number; message: string }> {
  return fetchJson('/api/v1/price-adjustment/apply', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function parseSupplierPriceFile(
  payload: FormData | { rawText?: string; loadServerSample?: boolean },
): Promise<ParseSupplierFileResponse> {
  if (payload instanceof FormData) {
    const res = await fetch('/api/v1/price-adjustment/parse-supplier-file', {
      method: 'POST',
      credentials: 'include',
      body: payload,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.detail || err.error || 'Erreur lors de lâ€™analyse du fichier');
    }
    return (await res.json()) as ParseSupplierFileResponse;
  }
  return fetchJson('/api/v1/price-adjustment/parse-supplier-file', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function commitSupplierMatches(body: {
  supplierName?: string;
  matches: readonly { productId: number; purchasePriceHt: number; purchaseVatRate?: number }[];
}): Promise<{ ok: boolean; updatedCount: number; message: string }> {
  return fetchJson('/api/v1/price-adjustment/commit-supplier-matches', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export interface MatchedProductItem {
  readonly id: number;
  readonly wcProductId: number;
  readonly sku: string;
  readonly name: string;
  readonly brand: string | null;
  readonly gtinCanonical: string | null;
  readonly currentRegularPriceTtc: number | null;
  readonly currentPurchasePriceHt: number | null;
  readonly image: string | null;
}

export function searchProductsForMatching(q: string, brand?: string): Promise<{ ok: boolean; products: readonly MatchedProductItem[] }> {
  const sp = new URLSearchParams({ q });
  if (brand) sp.set('brand', brand);
  return fetchJson(`/api/v1/price-adjustment/search-products?${sp.toString()}`);
}


// ============================================================================
// S32 â€” ContrÃ´le des Marges & Ajustement Woo
// ============================================================================
export interface MargeControlRowDto {
  readonly productId: number;
  readonly wcProductId: number;
  readonly wcParentId: number | null;
  readonly sku: string;
  readonly name: string;
  readonly brand: string | null;
  readonly image: string | null;
  readonly gtinCanonical: string | null;
  readonly barcodeRaw: string | null;
  readonly eanRaw: string | null;
  readonly purchaseSourceKey: string | null;
  readonly purchaseSourceLabel: string | null;
  readonly baseCostHt: number;
  readonly vatRate: number;
  readonly baseCostTtc: number;
  readonly hasDepotPromo: boolean;
  readonly promoLabel: string | null;
  readonly promoBuyQty: number | null;
  readonly promoFreeQty: number | null;
  readonly promoPercent: number | null;
  readonly effectiveCostHt: number;
  readonly effectiveCostTtc: number;
  readonly regularPriceTtc: number;
  readonly salePriceTtc: number | null;
  readonly sellingPriceTtc: number;
  readonly isSellingPromo: boolean;
  readonly marginAmountTtc: number;
  readonly marginRate: number;
  readonly markupRate: number;
  readonly isCritical: boolean;
  readonly lastPriceChange?: {
    readonly detectedAt: string;
    readonly source: string;
    readonly oldRegularTtc: number | null;
    readonly newRegularTtc: number | null;
    readonly authorBadge: {
      readonly isApp: boolean;
      readonly user: string;
      readonly context: string;
    };
  } | null | undefined;
}

export interface MargeControlTotalsDto {
  readonly totalWithCost: number;
  readonly criticalCount: number;
  readonly normalCount: number;
  readonly highCount: number;
  readonly promoCount: number;
  readonly avgMarginPct: number;
}

export interface MargeControlResponse {
  readonly rows: readonly MargeControlRowDto[];
  readonly totals: MargeControlTotalsDto;
  readonly pagination: {
    readonly page: number;
    readonly pageSize: number;
    readonly totalItems: number;
    readonly totalPages: number;
  };
  readonly brands: readonly string[];
}

export async function fetchMargeControl(params: {
  search?: string | undefined;
  brand?: string | undefined;
  excludedSubBrands?: string | undefined;
  marginFilter?: 'all' | 'critical' | 'normal' | 'high' | 'promo' | undefined;
  sort?: 'margin_asc' | 'margin_desc' | 'name_asc' | undefined;
  page?: number | undefined;
  pageSize?: number | undefined;
}): Promise<MargeControlResponse> {
  const sp = new URLSearchParams();
  if (params.search) sp.set('search', params.search);
  if (params.brand) sp.set('brand', params.brand);
  if (params.excludedSubBrands) sp.set('excludedSubBrands', params.excludedSubBrands);
  if (params.marginFilter) sp.set('marginFilter', params.marginFilter);
  if (params.sort) sp.set('sort', params.sort);
  if (params.page) sp.set('page', String(params.page));
  if (params.pageSize) sp.set('pageSize', String(params.pageSize));
  return fetchJson(`/api/v1/catalogue/marge-control?${sp.toString()}`);
}

export async function updateMargeControlPrice(payload: {
  productId: number;
  regularPriceTtc: number;
  salePriceTtc?: number | null;
}): Promise<{ ok: boolean; message: string; regularPriceTtc: number; salePriceTtc: number | null }> {
  return fetchJson('/api/v1/catalogue/marge-control/update-price', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export interface BulkUpdateMargeControlPayload {
  readonly items?: ReadonlyArray<{
    readonly productId: number;
    readonly regularPriceTtc: number; // millimes
    readonly salePriceTtc?: number | null | undefined;
  }> | undefined;
  readonly brand?: string | undefined;
  readonly targetMarkupPct?: number | undefined;
  readonly excludedSubBrands?: string | undefined;
}

export interface BulkUpdateMargeControlResult {
  readonly ok: boolean;
  readonly updatedCount: number;
  readonly totalRequested: number;
  readonly errors: readonly string[];
  readonly message: string;
}


export interface PriceChangeHistoryItemDto {
  readonly id: number;
  readonly productId: number;
  readonly wcProductId: number;
  readonly sku: string;
  readonly productName: string;
  readonly brand: string | null;
  readonly oldRegularTtc: number | null;
  readonly newRegularTtc: number | null;
  readonly oldSaleTtc: number | null;
  readonly newSaleTtc: number | null;
  readonly diffRegularTtc: number | null;
  readonly diffPct: number | null;
  readonly source: string;
  readonly authorBadge: {
    readonly isApp: boolean;
    readonly user: string;
    readonly context: string;
  };
  readonly detectedAt: string;
}

export interface PriceHistoryResponseDto {
  readonly items: readonly PriceChangeHistoryItemDto[];
  readonly total: number;
  readonly page: number;
  readonly pageSize: number;
}

export async function fetchPriceHistory(params?: {
  search?: string | undefined;
  sourceFilter?: 'all' | 'app' | 'woo' | undefined;
  productId?: number | undefined;
  page?: number | undefined;
  pageSize?: number | undefined;
}): Promise<PriceHistoryResponseDto> {
  const sp = new URLSearchParams();
  if (params?.search) sp.set('search', params.search);
  if (params?.sourceFilter) sp.set('sourceFilter', params.sourceFilter);
  if (params?.productId) sp.set('productId', String(params.productId));
  if (params?.page) sp.set('page', String(params.page));
  if (params?.pageSize) sp.set('pageSize', String(params.pageSize));

  const qs = sp.toString();
  return fetchJson(`/api/v1/catalogue/marge-control/price-history${qs ? `?${qs}` : ''}`);
}

export async function bulkUpdateMargeControlPrice(
  payload: BulkUpdateMargeControlPayload
): Promise<BulkUpdateMargeControlResult> {
  return fetchJson('/api/v1/catalogue/marge-control/bulk-update', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

// ---- S34 : Audit & Optimisation SEO Catalogue -------------------------------

export interface SeoAuditSummary {
  readonly totalEligible: number;
  readonly withBarcodeCount: number;
  readonly withConfirmedBarcodeCount: number;
  readonly withoutBarcodeCount: number;
  readonly withImagesCount: number;
  readonly withoutImagesCount: number;
  readonly withInStockCount: number;
  readonly outOfStockCount: number;
  readonly readyShoppingEstimated: number;
  readonly averageScore: number;
  readonly sampleAnalyzed: number;
  readonly distribution: {
    readonly good: number;
    readonly warning: number;
    readonly critical: number;
  };
  readonly titleMetrics: {
    readonly optimalRatio: number;
    readonly brandIncludedRatio: number;
  };
}

export interface SeoProductItem {
  readonly id: number;
  readonly wcProductId?: number | null;
  readonly sku: string | null;
  readonly name: string;
  readonly brand: string | null;
  readonly images: readonly string[];
  readonly gtinCanonical: string | null;
  readonly barcodeRaw: string | null;
  readonly eanRaw: string | null;
  readonly finalEanConfirmed: boolean;
  readonly regularPriceTtc: number | null;
  readonly salePriceTtc: number | null;
  readonly stockQty: number | null;
  readonly inStock: boolean | null;
  readonly wcType: string;
  readonly categories: readonly string[];
  readonly seo: {
    readonly score: number;
    readonly anomalies: readonly string[];
    readonly titleLength: number;
    readonly titleStatus: 'optimal' | 'short' | 'long';
    readonly hasBrandInTitle: boolean;
    readonly hasContenanceInTitle: boolean;
    readonly hasEan: boolean;
    readonly hasConfirmedEan: boolean;
    readonly imageCount: number;
    readonly hasImages: boolean;
    readonly hasMultiImages: boolean;
    readonly suggestedTitle: string;
    readonly suggestedAlt: string;
    readonly suggestedCaption: string;
    readonly suggestedMetaDesc: string;
    readonly isReadyForShopping: boolean;
  };
}

export interface SeoProductsResponse {
  readonly items: readonly SeoProductItem[];
  readonly pagination: {
    readonly total: number;
    readonly page: number;
    readonly limit: number;
    readonly totalPages: number;
  };
}

export function fetchSeoAuditSummary(): Promise<SeoAuditSummary> {
  return fetchJson('/api/v1/seo/audit-summary');
}

export function fetchSeoProducts(params?: {
  page?: number | undefined;
  limit?: number | undefined;
  deficiency?: string | undefined;
  search?: string | undefined;
  brand?: string | undefined;
  sortBy?: string | undefined;
}): Promise<SeoProductsResponse> {
  const sp = new URLSearchParams();
  if (params?.page) sp.set('page', String(params.page));
  if (params?.limit) sp.set('limit', String(params.limit));
  if (params?.deficiency) sp.set('deficiency', params.deficiency);
  if (params?.search) sp.set('search', params.search);
  if (params?.brand) sp.set('brand', params.brand);
  if (params?.sortBy) sp.set('sortBy', params.sortBy);
  const q = sp.toString();
  return fetchJson(`/api/v1/seo/products${q ? `?${q}` : ''}`);
}

export function fetchProductSchema(productId: number): Promise<{
  productId: number;
  schema: Record<string, unknown>;
  jsonString: string;
}> {
  return fetchJson(`/api/v1/seo/product/${productId}/schema`);
}

export function generateSeoAlts(productIds: number[]): Promise<{
  ok: boolean;
  count: number;
  suggestions: readonly {
    productId: number;
    wcProductId: number;
    name: string;
    imagesCount: number;
    images: readonly string[];
    suggested: {
      altText: string;
      caption: string;
      description: string;
      mediaTitle: string;
    };
  }[];
}> {
  return fetchJson('/api/v1/seo/generate-alts', {
    method: 'POST',
    body: JSON.stringify({ productIds }),
  });
}

export function pushSeoAltsWoo(items: readonly {
  productId: number;
  wcProductId: number;
  altText: string;
}[]): Promise<{
  ok: boolean;
  updatedCount: number;
  failedCount: number;
  errors: readonly string[];
}> {
  return fetchJson('/api/v1/seo/push-alts-woo', {
    method: 'POST',
    body: JSON.stringify({ items }),
  });
}



// --- Market Price Changes (Depots & Competitors) ---

export interface MarketPriceChangeItem {
  readonly id: number;
  readonly sourceId: number;
  readonly offerId: number;
  readonly productName: string;
  readonly brand: string | null;
  readonly gtin: string | null;
  readonly oldPriceTtc: number | null;
  readonly newPriceTtc: number | null;
  readonly oldPriceHt: number | null;
  readonly newPriceHt: number | null;
  readonly diffTtc: number | null;
  readonly diffPercent: number | null;
  readonly sourceKind: 'depot' | 'competitor' | string;
  readonly sourceKey: string;
  readonly sourceLabel: string;
  readonly url: string | null;
  readonly image: string | null;
  readonly detectedAt: string;
  readonly notifiedByEmail: boolean;
  readonly catalogProduct: {
    readonly id: number;
    readonly wcProductId: number;
    readonly sku: string;
    readonly name: string;
  } | null;
}

export interface MarketPriceChangesKpis {
  readonly total24h: number;
  readonly total7d: number;
  readonly totalDrops: number;
  readonly totalHikes: number;
  readonly depotsCount: number;
  readonly competitorsCount: number;
  readonly sources: readonly {
    readonly key: string;
    readonly label: string;
    readonly kind: string;
    readonly count: number;
  }[];
}

export interface MarketPriceChangesResponse {
  readonly items: readonly MarketPriceChangeItem[];
  readonly total: number;
  readonly page: number;
  readonly pageSize: number;
  readonly totalPages: number;
}

export function fetchMarketPriceChanges(params?: {
  kind?: string | undefined;
  sourceKey?: string | undefined;
  direction?: string | undefined;
  search?: string | undefined;
  startDate?: string | undefined;
  endDate?: string | undefined;
  page?: number | undefined;
  pageSize?: number | undefined;
}): Promise<MarketPriceChangesResponse> {
  const q = new URLSearchParams();
  if (params?.kind && params.kind !== 'all') q.set('kind', params.kind);
  if (params?.sourceKey && params.sourceKey !== 'all') q.set('sourceKey', params.sourceKey);
  if (params?.direction && params.direction !== 'all') q.set('direction', params.direction);
  if (params?.search) q.set('search', params.search);
  if (params?.startDate) q.set('startDate', params.startDate);
  if (params?.endDate) q.set('endDate', params.endDate);
  if (params?.page) q.set('page', String(params.page));
  if (params?.pageSize) q.set('pageSize', String(params.pageSize));
  const query = q.toString();
  return fetchJson('/api/v1/market-price-changes' + (query ? '?' + query : ''));
}

export function fetchMarketPriceChangesKpis(): Promise<MarketPriceChangesKpis> {
  return fetchJson('/api/v1/market-price-changes/kpis');
}

// ============================================================================
// S45 — Conformité Meta Commerce (Facebook & Instagram Ads)
// ============================================================================

export interface MetaCommerceIssue {
  readonly code: 'PRICE_MISSING' | 'PRICE_DECIMALS' | 'IMAGE_MISSING' | 'IMAGE_FETCH_FAILED' | 'IMAGE_TOO_SMALL' | 'GTIN_INVALID';
  readonly severity: 'error' | 'warning';
  readonly title: string;
  readonly description: string;
}

export interface MetaCommerceProductItem {
  readonly id: number;
  readonly wcProductId: number;
  readonly wcParentId: number | null;
  readonly sku: string;
  readonly name: string;
  readonly brand: string | null;
  readonly image: string | null;
  readonly images: readonly string[];
  readonly regularPriceTtc: number | null;
  readonly salePriceTtc: number | null;
  readonly isPromo: boolean;
  readonly isVariable: boolean;
  readonly variantsCount: number;
  readonly priceTndFormatted: string;
  readonly regularPriceTndFormatted: string | null;
  readonly salePriceTndFormatted: string | null;
  readonly priceDecimals: number;
  readonly suggestedRoundedPriceTnd: string | null;
  readonly suggestedRoundedPriceMillimes: number | null;
  readonly barcode: string | null;
  readonly gtinChecksumOk: boolean;
  readonly stockQty: number | null;
  readonly inStock: boolean | null;
  readonly visibility: string;
  readonly isParked: boolean;
  readonly issues: readonly MetaCommerceIssue[];
}

export interface MetaCommerceAuditCounts {
  readonly totalPublished: number;
  readonly totalWithIssues: number;
  readonly criticalErrorsCount: number;
  readonly qualityWarningsCount: number;
  readonly priceMissingCount: number;
  readonly priceDecimalsCount: number;
  readonly imageMissingCount: number;
  readonly imageSmallCount: number;
  readonly gtinInvalidCount: number;
  readonly parkedCount: number;
}

export interface MetaCommerceBrandCount {
  readonly brand: string;
  readonly count: number;
}

export interface MetaCommerceAuditResponse {
  readonly tab: string;
  readonly counts: MetaCommerceAuditCounts;
  readonly page: number;
  readonly limit: number;
  readonly total: number;
  readonly totalPages: number;
  readonly brands: readonly MetaCommerceBrandCount[];
  readonly items: readonly MetaCommerceProductItem[];
}

export function fetchMetaCommerceAudit(params?: {
  tab?: string | undefined;
  q?: string | undefined;
  brand?: string | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}): Promise<MetaCommerceAuditResponse> {
  const q = new URLSearchParams();
  if (params?.tab && params.tab !== 'all') q.set('tab', params.tab);
  if (params?.q) q.set('q', params.q);
  if (params?.brand && params.brand !== 'all') q.set('brand', params.brand);
  if (params?.page) q.set('page', String(params.page));
  if (params?.limit) q.set('limit', String(params.limit));
  const query = q.toString();
  return fetchJson('/api/v1/catalogue/meta-commerce' + (query ? '?' + query : ''));
}

export function roundMetaCommercePrices(productIds: number[]): Promise<{
  ok: boolean;
  updatedCount: number;
  errors: string[];
}> {
  return fetchJson('/api/v1/catalogue/meta-commerce/round-prices', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ productIds }),
  });
}

export function parkMetaCommerceStock(productIds: number[]): Promise<{
  ok: boolean;
  batchId: number;
  quantity: number;
  sent: number;
  verified: number;
  failed: number;
  errors: string[];
}> {
  return fetchJson('/api/v1/catalogue/meta-commerce/park-stock', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ productIds }),
  });
}
